const alpine = "/img/school district/Alpine School District.webp";
const beaver = "/img/school district/Beaver School District.webp";
const boxelder = "/img/school district/Box Elder School District.webp";
const cache = "/img/school district/Cache County School District.webp";
const canyons = "/img/school district/canyons.webp";
const carbon = "/img/school district/Carbon School District.webp";
const daggett = "/img/school district/Daggett School District.webp";
const davis = "/img/school district/Davis School District.webp";
const duchesne = "/img/school district/Duchesne County School District.webp";
const emery = "/img/school district/Emery County School District.webp";
const garfield = "/img/school district/Garfield School District.webp";
const grand = "/img/school district/Grand County School District.webp";
const granite = "/img/school district/Granite School District.webp";
const iron = "/img/school district/Iron County School District.webp";
const jordan = "/img/school district/Jordan School District.webp";
const juab = "/img/school district/Juab School District.webp";
const kane = "/img/school district/Kane School District.webp";
const logan = "/img/school district/logan School District.webp";
const millard = "/img/school district/Millard School District.webp";
const morgan = "/img/school district/Morgan School District.webp";
const murray = "/img/school district/Murray School District.webp";
const nebo = "/img/school district/Nebo School District.webp";
const North = "/img/school district/North Sanpete School District.webp";
const northsummit = "/img/school district/North Summit School District.webp";
const ogden = "/img/school district/Ogden School District.webp";
const park = "/img/school district/Park City School District.webp";
const piute = "/img/school district/Piute School District.webp";
const provo = "/img/school district/Provo City School District.webp";
const rich = "/img/school district/Rich School District.webp";
const saltLake = "/img/school district/Salt Lake City School District.webp";
const san = "/img/school district/San Juan School District.webp";
const sevier = "/img/school district/Sevier School District.webp";
const southSanpete = "/img/school district/South Sanpette School District.webp";
const southSummit = "/img/school district/South Summit School District.webp";
const tintic = "/img/school district/Tintic School District.webp";
const tooele = "/img/school district/Tooele County School District.webp";
const uintah = "/img/school district/Unitah School District.webp";
const wasatch = "/img/school district/Wasatch County School District.webp";
const washington =
  "/img/school district/Washington County School District.webp";
const wayne = "/img/school district/Wayne County School District.webp";
const weber = "/img/school district/Weber School District.webp";

export const schoolDistricts = {
  alpine: {
    districtName: "Alpine",
    // county: "Utah",
    // totalSchools: 92,
    schools: [
      {
        schoolName: "Alpine Online School",
        numberOfStudents: 110,
        grades: "KG-8",
      },
      { schoolName: "Alpine School", numberOfStudents: 643, grades: "PK-6" },
      {
        schoolName: "American Fork High",
        numberOfStudents: 2412,
        grades: "10-12",
      },
      {
        schoolName: "American Fork Jr High",
        numberOfStudents: 1894,
        grades: "7-9",
      },
      { schoolName: "Aspen School", numberOfStudents: 421, grades: "PK-6" },
      { schoolName: "Barratt School", numberOfStudents: 564, grades: "PK-6" },
      { schoolName: "Belmont School", numberOfStudents: 1036, grades: "PK-6" },
      {
        schoolName: "Black Ridge School",
        numberOfStudents: 1191,
        grades: "PK-6",
      },
      {
        schoolName: "Bonneville School",
        numberOfStudents: 566,
        grades: "PK-6",
      },
      {
        schoolName: "Brookhaven School",
        numberOfStudents: 1037,
        grades: "PK-6",
      },
      {
        schoolName: "Canyon View Jr High",
        numberOfStudents: 1112,
        grades: "7-9",
      },
      { schoolName: "Cascade School", numberOfStudents: 767, grades: "PK-6" },
      {
        schoolName: "Cedar Ridge School",
        numberOfStudents: 682,
        grades: "PK-6",
      },
      {
        schoolName: "Cedar Valley High",
        numberOfStudents: 2924,
        grades: "7-12",
      },
      {
        schoolName: "Cedar Valley School",
        numberOfStudents: 118,
        grades: "PK-6",
      },
      {
        schoolName: "Centennial Elementary",
        numberOfStudents: 729,
        grades: "PK-6",
      },
      { schoolName: "Central School", numberOfStudents: 496, grades: "PK-6" },
      {
        schoolName: "Cherry Hill School",
        numberOfStudents: 733,
        grades: "PK-6",
      },
      { schoolName: "Dan W. Peterson", numberOfStudents: 227, grades: "PK-12" },
      { schoolName: "Deerfield School", numberOfStudents: 603, grades: "PK-6" },
      {
        schoolName: "Dry Creek School",
        numberOfStudents: 1127,
        grades: "PK-6",
      },
      {
        schoolName: "Eaglecrest School",
        numberOfStudents: 855,
        grades: "PK-6",
      },
      {
        schoolName: "Eagle Valley School",
        numberOfStudents: 970,
        grades: "PK-6",
      },
      { schoolName: "East Shore Online", numberOfStudents: 0, grades: "9-12" },
      { schoolName: "Foothill School", numberOfStudents: 582, grades: "PK-6" },
      { schoolName: "Forbes School", numberOfStudents: 424, grades: "KG-6" },
      {
        schoolName: "Fox Hollow School",
        numberOfStudents: 776,
        grades: "PK-6",
      },
      { schoolName: "Freedom School", numberOfStudents: 758, grades: "PK-6" },
      {
        schoolName: "Frontier Middle School",
        numberOfStudents: 1634,
        grades: "7-9",
      },
      { schoolName: "Greenwood School", numberOfStudents: 928, grades: "PK-6" },
      {
        schoolName: "Grovecrest School",
        numberOfStudents: 630,
        grades: "PK-6",
      },
      {
        schoolName: "Harbor Point Elementary",
        numberOfStudents: 717,
        grades: "PK-6",
      },
      { schoolName: "Harvest School", numberOfStudents: 1046, grades: "PK-6" },
      {
        schoolName: "Hidden Hollow School",
        numberOfStudents: 1124,
        grades: "PK-6",
      },
      { schoolName: "Highland School", numberOfStudents: 645, grades: "PK-6" },
      { schoolName: "Horizon School", numberOfStudents: 142, grades: "PK-12" },
      {
        schoolName: "Lake Mountain Middle",
        numberOfStudents: 1412,
        grades: "7-9",
      },
      {
        schoolName: "Lakeridge Jr High",
        numberOfStudents: 1388,
        grades: "7-9",
      },
      { schoolName: "Legacy School", numberOfStudents: 844, grades: "PK-6" },
      { schoolName: "Lehi High", numberOfStudents: 1982, grades: "10-12" },
      { schoolName: "Lehi Jr High", numberOfStudents: 995, grades: "7-9" },
      { schoolName: "Lehi School", numberOfStudents: 520, grades: "PK-6" },
      {
        schoolName: "Liberty Hills Elementary",
        numberOfStudents: 761,
        grades: "PK-6",
      },
      { schoolName: "Lindon School", numberOfStudents: 639, grades: "PK-6" },
      { schoolName: "Lone Peak High", numberOfStudents: 2469, grades: "10-12" },
      { schoolName: "Manila School", numberOfStudents: 548, grades: "PK-6" },
      { schoolName: "Meadow School", numberOfStudents: 680, grades: "PK-6" },
      {
        schoolName: "Mountain Ridge Jr High",
        numberOfStudents: 1073,
        grades: "7-9",
      },
      {
        schoolName: "Mountain Trails School",
        numberOfStudents: 1289,
        grades: "PK-6",
      },
      {
        schoolName: "Mountain View High",
        numberOfStudents: 1508,
        grades: "10-12",
      },
      {
        schoolName: "Mount Mahogany School",
        numberOfStudents: 661,
        grades: "PK-6",
      },
      {
        schoolName: "North Point School",
        numberOfStudents: 1022,
        grades: "PK-6",
      },
      {
        schoolName: "Northridge School",
        numberOfStudents: 462,
        grades: "PK-6",
      },
      {
        schoolName: "Oak Canyon Jr High",
        numberOfStudents: 1334,
        grades: "7-10",
      },
      { schoolName: "Orchard School", numberOfStudents: 710, grades: "PK-6" },
      { schoolName: "Orem High", numberOfStudents: 1287, grades: "10-12" },
      { schoolName: "Orem Jr High", numberOfStudents: 961, grades: "7-9" },
      { schoolName: "Orem School", numberOfStudents: 716, grades: "PK-6" },
      {
        schoolName: "Parkside Elementary",
        numberOfStudents: 621,
        grades: "PK-6",
      },
      {
        schoolName: "Pleasant Grove High",
        numberOfStudents: 2084,
        grades: "10-12",
      },
      {
        schoolName: "Pleasant Grove Jr High",
        numberOfStudents: 1256,
        grades: "7-9",
      },
      {
        schoolName: "Polaris High School",
        numberOfStudents: 194,
        grades: "9-12",
      },
      {
        schoolName: "Pony Express School",
        numberOfStudents: 1128,
        grades: "PK-6",
      },
      { schoolName: "Ridgeline School", numberOfStudents: 886, grades: "PK-6" },
      {
        schoolName: "River Rock School",
        numberOfStudents: 1049,
        grades: "PK-6",
      },
      { schoolName: "Riverview School", numberOfStudents: 977, grades: "PK-6" },
      {
        schoolName: "Rocky Mountain School",
        numberOfStudents: 604,
        grades: "PK-6",
      },
      {
        schoolName: "Sage Hills School",
        numberOfStudents: 943,
        grades: "PK-6",
      },
      {
        schoolName: "Saratoga Shores School",
        numberOfStudents: 782,
        grades: "PK-6",
      },
      { schoolName: "Sego Lily School", numberOfStudents: 706, grades: "PK-6" },
      { schoolName: "Serv By Appt", numberOfStudents: 0, grades: "PK-3" },
      { schoolName: "Sharon School", numberOfStudents: 336, grades: "PK-6" },
      { schoolName: "Shelley School", numberOfStudents: 814, grades: "PK-6" },
      {
        schoolName: "Silver Lake Elementary",
        numberOfStudents: 762,
        grades: "PK-6",
      },
      {
        schoolName: "Skyridge High School",
        numberOfStudents: 2387,
        grades: "9-12",
      },
      {
        schoolName: "Snow Springs School",
        numberOfStudents: 824,
        grades: "PK-6",
      },
      {
        schoolName: "Springside School",
        numberOfStudents: 735,
        grades: "PK-6",
      },
      { schoolName: "Summit High", numberOfStudents: 115, grades: "7-12" },
      {
        schoolName: "Thunder Ridge School",
        numberOfStudents: 1051,
        grades: "PK-6",
      },
      {
        schoolName: "Timberline Middle",
        numberOfStudents: 1315,
        grades: "7-9",
      },
      {
        schoolName: "Timpanogos High",
        numberOfStudents: 1365,
        grades: "10-12",
      },
      {
        schoolName: "Trailside Elementary",
        numberOfStudents: 909,
        grades: "PK-6",
      },
      {
        schoolName: "Traverse Mountain School",
        numberOfStudents: 737,
        grades: "PK-6",
      },
      {
        schoolName: "Valley View School",
        numberOfStudents: 424,
        grades: "PK-6",
      },
      { schoolName: "Viewpoint Middle", numberOfStudents: 1790, grades: "7-9" },
      { schoolName: "Vineyard School", numberOfStudents: 798, grades: "PK-6" },
      {
        schoolName: "Vista Heights Middle",
        numberOfStudents: 1519,
        grades: "7-10",
      },
      { schoolName: "Westfield School", numberOfStudents: 642, grades: "PK-6" },
      { schoolName: "Westlake High", numberOfStudents: 2659, grades: "10-12" },
      { schoolName: "Westmore School", numberOfStudents: 525, grades: "PK-6" },
      {
        schoolName: "Willowcreek Middle",
        numberOfStudents: 1746,
        grades: "7-9",
      },
      { schoolName: "Windsor School", numberOfStudents: 569, grades: "PK-6" },
    ],
    // logo: alpine // import your logo
  },
  beaver: {
    districtName: "Beaver",
    // county: "Beaver",
    // totalSchools: 7,
    schools: [
      {
        schoolName: "Beaver High",
        numberOfStudents: 481,
        grades: "7-12",
      },
      {
        schoolName: "Beaver Preschool",
        numberOfStudents: 54,
        grades: "PK-PK",
      },
      {
        schoolName: "Belknap School",
        numberOfStudents: 458,
        grades: "KG-6",
      },
      {
        schoolName: "Milford High",
        numberOfStudents: 222,
        grades: "7-12",
      },
      {
        schoolName: "Milford School",
        numberOfStudents: 215,
        grades: "KG-6",
      },
      {
        schoolName: "Minersville School",
        numberOfStudents: 41,
        grades: "6-8",
      },
      {
        schoolName: "Minersville School",
        numberOfStudents: 90,
        grades: "KG-5",
      },
    ],
    // logo: beaver // import your logo
  },
  // "boxelder" cache canyons carbon daggett davis duchesne emery garfield grand granite iron jordan juab kane logan millard morgan murray nebo sanpete summit ogden park piute provo rich salt san sevier southSanpete southSummit tintic tooele uintah wasatch washington wayne weber
  boxelder: {
    districtName: "Box Elder",
    schools: [
      {
        schoolName: "Bear River High",
        numberOfStudents: 1172,
        grades: "10-12",
      },
      {
        schoolName: "Bear River Middle",
        numberOfStudents: 843,
        grades: "8-10",
      },
      {
        schoolName: "Box Elder High",
        numberOfStudents: 1583,
        grades: "10-12",
      },
      {
        schoolName: "Box Elder Middle",
        numberOfStudents: 1153,
        grades: "8-9",
      },
      {
        schoolName: "Century School",
        numberOfStudents: 491,
        grades: "KG-5",
      },
      {
        schoolName: "Corinne Early Learning Center",
        numberOfStudents: 0,
        grades: "PK-PK",
      },
      {
        schoolName: "Discovery School",
        numberOfStudents: 466,
        grades: "KG-5",
      },
      {
        schoolName: "Fielding School",
        numberOfStudents: 579,
        grades: "KG-5",
      },
      {
        schoolName: "Garland School",
        numberOfStudents: 660,
        grades: "KG-5",
      },
      {
        schoolName: "Golden Spike Elementary",
        numberOfStudents: 838,
        grades: "PK-5",
      },
      {
        schoolName: "Grouse Creek Elementary",
        numberOfStudents: 5,
        grades: "KG-6",
      },
      {
        schoolName: "Grouse Creek Secondary",
        numberOfStudents: 1,
        grades: "7-10",
      },
      {
        schoolName: "Harris Intermediate",
        numberOfStudents: 813,
        grades: "6-7",
      },
      {
        schoolName: "Lake View School",
        numberOfStudents: 609,
        grades: "KG-5",
      },
      {
        schoolName: "Mckinley School",
        numberOfStudents: 607,
        grades: "PK-5",
      },
      {
        schoolName: "North Park School",
        numberOfStudents: 635,
        grades: "PK-5",
      },
      {
        schoolName: "Park Valley Elementary",
        numberOfStudents: 22,
        grades: "KG-6",
      },
      {
        schoolName: "Park Valley Secondary",
        numberOfStudents: 5,
        grades: "7-10",
      },
      {
        schoolName: "Snowville School",
        numberOfStudents: 27,
        grades: "KG-5",
      },
      {
        schoolName: "Sunrise High School",
        numberOfStudents: 159,
        grades: "5-12",
      },
      {
        schoolName: "Three Mile Creek School",
        numberOfStudents: 604,
        grades: "2-5",
      },
      {
        schoolName: "Willard School",
        numberOfStudents: 298,
        grades: "PK-1",
      },
      {
        schoolName: "Young Intermediate",
        numberOfStudents: 1079,
        grades: "6-7",
      },
    ],
  },
  cache: {
    districtName: "Cache County",
    schools: [
      {
        schoolName: "Birch Creek School",
        numberOfStudents: 721,
        grades: "PK-6",
      },
      {
        schoolName: "Cache High",
        numberOfStudents: 151,
        grades: "5-12",
      },
      {
        schoolName: "Cache Preschool",
        numberOfStudents: 62,
        grades: "PK-PK",
      },
      {
        schoolName: "Canyon School",
        numberOfStudents: 752,
        grades: "PK-6",
      },
      {
        schoolName: "Cedar Ridge School",
        numberOfStudents: 744,
        grades: "KG-6",
      },
      {
        schoolName: "Green Canyon High School",
        numberOfStudents: 1690,
        grades: "8-12",
      },
      {
        schoolName: "Greenville School",
        numberOfStudents: 537,
        grades: "PK-6",
      },
      {
        schoolName: "Heritage School",
        numberOfStudents: 758,
        grades: "PK-6",
      },
      {
        schoolName: "Lewiston School",
        numberOfStudents: 533,
        grades: "PK-6",
      },
      {
        schoolName: "Lincoln School",
        numberOfStudents: 516,
        grades: "KG-6",
      },
      {
        schoolName: "Millville School",
        numberOfStudents: 484,
        grades: "PK-6",
      },
      {
        schoolName: "Mountain Crest High",
        numberOfStudents: 1538,
        grades: "8-12",
      },
      {
        schoolName: "Mountainside School",
        numberOfStudents: 500,
        grades: "PK-6",
      },
      {
        schoolName: "Nibley School",
        numberOfStudents: 530,
        grades: "PK-6",
      },
      {
        schoolName: "North Cache Middle School",
        numberOfStudents: 1119,
        grades: "7-8",
      },
      {
        schoolName: "North Park School",
        numberOfStudents: 501,
        grades: "PK-6",
      },
      {
        schoolName: "Providence School",
        numberOfStudents: 760,
        grades: "KG-6",
      },
      {
        schoolName: "Ridgeline High School",
        numberOfStudents: 1813,
        grades: "8-12",
      },
      {
        schoolName: "River Heights School",
        numberOfStudents: 622,
        grades: "PK-6",
      },
      {
        schoolName: "Sky View High",
        numberOfStudents: 1517,
        grades: "8-12",
      },
      {
        schoolName: "South Cache Middle School",
        numberOfStudents: 1063,
        grades: "7-8",
      },
      {
        schoolName: "Spring Creek Middle School",
        numberOfStudents: 845,
        grades: "7-8",
      },
      {
        schoolName: "Summit School",
        numberOfStudents: 738,
        grades: "PK-6",
      },
      {
        schoolName: "Sunrise School",
        numberOfStudents: 782,
        grades: "KG-6",
      },
      {
        schoolName: "Wellsville School",
        numberOfStudents: 512,
        grades: "KG-6",
      },
      {
        schoolName: "White Pine School",
        numberOfStudents: 439,
        grades: "PK-6",
      },
    ],
  },
  canyons: {
    districtName: "Canyons",
    schools: [
      {
        schoolName: "Albion Middle",
        numberOfStudents: 958,
        grades: "6-8",
      },
      {
        schoolName: "Alta High",
        numberOfStudents: 2294,
        grades: "8-12",
      },
      {
        schoolName: "Altara School",
        numberOfStudents: 538,
        grades: "KG-5",
      },
      {
        schoolName: "Alta View School",
        numberOfStudents: 581,
        grades: "KG-5",
      },
      {
        schoolName: "Bella Vista School",
        numberOfStudents: 202,
        grades: "KG-5",
      },
      {
        schoolName: "Brighton High",
        numberOfStudents: 2360,
        grades: "8-12",
      },
      {
        schoolName: "Brookwood School",
        numberOfStudents: 389,
        grades: "KG-5",
      },
      {
        schoolName: "Butler Middle",
        numberOfStudents: 895,
        grades: "6-8",
      },
      {
        schoolName: "Butler School",
        numberOfStudents: 605,
        grades: "KG-5",
      },
      {
        schoolName: "Canyons Online",
        numberOfStudents: 163,
        grades: "KG-8",
      },
      {
        schoolName: "Canyons Technical Education Center",
        numberOfStudents: 0,
        grades: "7-12",
      },
      {
        schoolName: "Canyons Transition Academy",
        numberOfStudents: 46,
        grades: "12-12",
      },
      {
        schoolName: "Canyons Virtual High School",
        numberOfStudents: 0,
        grades: "6-12",
      },
      {
        schoolName: "Canyon View School",
        numberOfStudents: 500,
        grades: "KG-5",
      },
      {
        schoolName: "Copperview School",
        numberOfStudents: 399,
        grades: "KG-5",
      },
      {
        schoolName: "Corner Canyon High",
        numberOfStudents: 2434,
        grades: "8-12",
      },
      {
        schoolName: "Crescent School",
        numberOfStudents: 423,
        grades: "KG-5",
      },
      {
        schoolName: "Diamond Ridge High School",
        numberOfStudents: 97,
        grades: "6-12",
      },
      {
        schoolName: "Draper Park Middle",
        numberOfStudents: 1494,
        grades: "6-8",
      },
      {
        schoolName: "Draper School",
        numberOfStudents: 677,
        grades: "KG-5",
      },
      {
        schoolName: "East Midvale School",
        numberOfStudents: 516,
        grades: "KG-5",
      },
      {
        schoolName: "Eastmont Middle",
        numberOfStudents: 594,
        grades: "6-8",
      },
      {
        schoolName: "East Sandy School",
        numberOfStudents: 377,
        grades: "KG-5",
      },
      {
        schoolName: "Entrada",
        numberOfStudents: 25,
        grades: "KG-12",
      },
      {
        schoolName: "Glacier Hills Elementary",
        numberOfStudents: 586,
        grades: "KG-5",
      },
      {
        schoolName: "Goldminer'S Daughter",
        numberOfStudents: 5,
        grades: "KG-8",
      },
      {
        schoolName: "Granite School",
        numberOfStudents: 355,
        grades: "KG-5",
      },
      {
        schoolName: "Hillcrest High",
        numberOfStudents: 2296,
        grades: "8-12",
      },
      {
        schoolName: "Indian Hills Middle",
        numberOfStudents: 1114,
        grades: "6-8",
      },
      {
        schoolName: "Jordan High",
        numberOfStudents: 1785,
        grades: "8-12",
      },
      {
        schoolName: "Jordan Valley School",
        numberOfStudents: 98,
        grades: "KG-12",
      },
      {
        schoolName: "Lone Peak School",
        numberOfStudents: 580,
        grades: "KG-5",
      },
      {
        schoolName: "Midvale Middle",
        numberOfStudents: 907,
        grades: "6-8",
      },
      {
        schoolName: "Midvale School",
        numberOfStudents: 722,
        grades: "KG-5",
      },
      {
        schoolName: "Midvalley School",
        numberOfStudents: 549,
        grades: "KG-5",
      },
      {
        schoolName: "Mt. Jordan Middle",
        numberOfStudents: 776,
        grades: "6-8",
      },
      {
        schoolName: "Oakdale School",
        numberOfStudents: 397,
        grades: "KG-5",
      },
      {
        schoolName: "Oak Hollow School",
        numberOfStudents: 570,
        grades: "KG-5",
      },
      {
        schoolName: "Park Lane School",
        numberOfStudents: 343,
        grades: "KG-5",
      },
      {
        schoolName: "Peruvian Park School",
        numberOfStudents: 505,
        grades: "KG-5",
      },
      {
        schoolName: "Quail Hollow School",
        numberOfStudents: 452,
        grades: "KG-5",
      },
      {
        schoolName: "Ridgecrest School",
        numberOfStudents: 547,
        grades: "KG-5",
      },
      {
        schoolName: "Sandy School",
        numberOfStudents: 512,
        grades: "PK-5",
      },
      {
        schoolName: "Silver Mesa School",
        numberOfStudents: 577,
        grades: "KG-5",
      },
      {
        schoolName: "Special Ed Preschool",
        numberOfStudents: 340,
        grades: "PK-PK",
      },
      {
        schoolName: "Sprucewood School",
        numberOfStudents: 319,
        grades: "KG-5",
      },
      {
        schoolName: "Sunrise School",
        numberOfStudents: 602,
        grades: "KG-5",
      },
      {
        schoolName: "Union Middle",
        numberOfStudents: 862,
        grades: "6-8",
      },
      {
        schoolName: "Willow Canyon School",
        numberOfStudents: 356,
        grades: "KG-5",
      },
      {
        schoolName: "Willow Springs School",
        numberOfStudents: 664,
        grades: "KG-5",
      },
    ],
  },
  carbon: {
    districtName: "Carbon",
    schools: [
      {
        schoolName: "Bruin Point School",
        numberOfStudents: 97,
        grades: "PK-5",
      },
      {
        schoolName: "Carbon High",
        numberOfStudents: 1023,
        grades: "9-12",
      },
      {
        schoolName: "Castle Heights School",
        numberOfStudents: 422,
        grades: "KG-5",
      },
      {
        schoolName: "Castle Valley Center",
        numberOfStudents: 85,
        grades: "PK-12",
      },
      {
        schoolName: "Creekview School",
        numberOfStudents: 450,
        grades: "PK-5",
      },
      {
        schoolName: "Helper Middle",
        numberOfStudents: 205,
        grades: "6-8",
      },
      {
        schoolName: "Mont Harmon Middle",
        numberOfStudents: 601,
        grades: "6-8",
      },
      {
        schoolName: "Sally Mauro School",
        numberOfStudents: 318,
        grades: "PK-5",
      },
      {
        schoolName: "Wellington School",
        numberOfStudents: 267,
        grades: "PK-5",
      },
    ],
  },
  daggett: {
    districtName: "Daggett",
    schools: [
      {
        schoolName: "Daggett Preschool",
        numberOfStudents: 0,
        grades: "PK-PK",
      },
      {
        schoolName: "Flaming Gorge School",
        numberOfStudents: 25,
        grades: "PK-5",
      },
      {
        schoolName: "Manila High",
        numberOfStudents: 112,
        grades: "7-12",
      },
      {
        schoolName: "Manila School",
        numberOfStudents: 79,
        grades: "PK-6",
      },
    ],
  },
  davis: {
    districtName: "Davis",
    schools: [
      {
        schoolName: "Adams School",
        numberOfStudents: 652,
        grades: "PK-6",
      },
      {
        schoolName: "Adelaide School",
        numberOfStudents: 419,
        grades: "PK-6",
      },
      {
        schoolName: "Antelope School",
        numberOfStudents: 693,
        grades: "PK-6",
      },
      {
        schoolName: "Bluff Ridge School",
        numberOfStudents: 866,
        grades: "PK-6",
      },
      {
        schoolName: "Boulton School",
        numberOfStudents: 506,
        grades: "PK-6",
      },
      {
        schoolName: "Bountiful High",
        numberOfStudents: 1482,
        grades: "10-12",
      },
      {
        schoolName: "Bountiful Jr High",
        numberOfStudents: 630,
        grades: "7-9",
      },
      {
        schoolName: "Bountiful School",
        numberOfStudents: 478,
        grades: "KG-6",
      },
      {
        schoolName: "Buffalo Point School",
        numberOfStudents: 938,
        grades: "PK-6",
      },
      {
        schoolName: "Canyon Creek School",
        numberOfStudents: 832,
        grades: "PK-6",
      },
      {
        schoolName: "Catalyst Center",
        numberOfStudents: 0,
        grades: "9-12",
      },
      {
        schoolName: "Centennial Jr High",
        numberOfStudents: 1033,
        grades: "7-9",
      },
      {
        schoolName: "Centerville Jr High",
        numberOfStudents: 976,
        grades: "7-9",
      },
      {
        schoolName: "Centerville School",
        numberOfStudents: 342,
        grades: "PK-6",
      },
      {
        schoolName: "Central Davis Jr High",
        numberOfStudents: 1009,
        grades: "7-9",
      },
      {
        schoolName: "Clearfield High",
        numberOfStudents: 2030,
        grades: "10-12",
      },
      {
        schoolName: "Clinton School",
        numberOfStudents: 464,
        grades: "PK-6",
      },
      {
        schoolName: "Columbia School",
        numberOfStudents: 569,
        grades: "KG-6",
      },
      {
        schoolName: "Cook School",
        numberOfStudents: 896,
        grades: "PK-6",
      },
      {
        schoolName: "Creekside School",
        numberOfStudents: 613,
        grades: "PK-6",
      },
      {
        schoolName: "Crestview School",
        numberOfStudents: 362,
        grades: "PK-6",
      },
      {
        schoolName: "Davis Connect 7-12",
        numberOfStudents: 340,
        grades: "7-12",
      },
      {
        schoolName: "Davis Connect 7-8",
        numberOfStudents: 0,
        grades: "7-8",
      },
      {
        schoolName: "Davis Connect K-6",
        numberOfStudents: 167,
        grades: "KG-8",
      },
      {
        schoolName: "Davis High",
        numberOfStudents: 2175,
        grades: "10-12",
      },
      {
        schoolName: "Doxey School",
        numberOfStudents: 301,
        grades: "PK-6",
      },
      {
        schoolName: "Eagle Bay School",
        numberOfStudents: 536,
        grades: "PK-6",
      },
      {
        schoolName: "East Layton School",
        numberOfStudents: 624,
        grades: "PK-6",
      },
      {
        schoolName: "Ellison Park School",
        numberOfStudents: 624,
        grades: "PK-6",
      },
      {
        schoolName: "Endeavour School",
        numberOfStudents: 740,
        grades: "KG-6",
      },
      {
        schoolName: "Fairfield Jr High",
        numberOfStudents: 1026,
        grades: "7-9",
      },
      {
        schoolName: "Family Enrichment Center",
        numberOfStudents: 220,
        grades: "PK-PK",
      },
      {
        schoolName: "Farmington High",
        numberOfStudents: 2083,
        grades: "10-12",
      },
      {
        schoolName: "Farmington Jr High",
        numberOfStudents: 1293,
        grades: "7-9",
      },
      {
        schoolName: "Farmington School",
        numberOfStudents: 498,
        grades: "KG-6",
      },
      {
        schoolName: "Foxboro School",
        numberOfStudents: 608,
        grades: "PK-6",
      },
      {
        schoolName: "Fremont School",
        numberOfStudents: 268,
        grades: "PK-6",
      },
      {
        schoolName: "H C Burton School",
        numberOfStudents: 671,
        grades: "PK-6",
      },
      {
        schoolName: "Heritage School",
        numberOfStudents: 737,
        grades: "PK-6",
      },
      {
        schoolName: "Hill Field School",
        numberOfStudents: 502,
        grades: "PK-6",
      },
      {
        schoolName: "Holbrook School",
        numberOfStudents: 525,
        grades: "PK-6",
      },
      {
        schoolName: "Holt School",
        numberOfStudents: 458,
        grades: "PK-6",
      },
      {
        schoolName: "Kay'S Creek Elementary",
        numberOfStudents: 688,
        grades: "KG-6",
      },
      {
        schoolName: "Kaysville Jr High",
        numberOfStudents: 965,
        grades: "7-9",
      },
      {
        schoolName: "Kaysville School",
        numberOfStudents: 524,
        grades: "PK-6",
      },
      {
        schoolName: "King School",
        numberOfStudents: 511,
        grades: "PK-6",
      },
      {
        schoolName: "Knowlton School",
        numberOfStudents: 718,
        grades: "PK-6",
      },
      {
        schoolName: "Lakeside School",
        numberOfStudents: 842,
        grades: "PK-6",
      },
      {
        schoolName: "Layton High",
        numberOfStudents: 2242,
        grades: "10-12",
      },
      {
        schoolName: "Layton School",
        numberOfStudents: 573,
        grades: "KG-6",
      },
      {
        schoolName: "Legacy Jr High",
        numberOfStudents: 1088,
        grades: "7-9",
      },
      {
        schoolName: "Lincoln School",
        numberOfStudents: 703,
        grades: "PK-6",
      },
      {
        schoolName: "Meadowbrook School",
        numberOfStudents: 419,
        grades: "PK-6",
      },
      {
        schoolName: "Millcreek Jr High",
        numberOfStudents: 689,
        grades: "7-9",
      },
      {
        schoolName: "Morgan School",
        numberOfStudents: 640,
        grades: "PK-6",
      },
      {
        schoolName: "Mountain High",
        numberOfStudents: 200,
        grades: "10-12",
      },
      {
        schoolName: "Mountain View School",
        numberOfStudents: 781,
        grades: "PK-6",
      },
      {
        schoolName: "Mueller Park Jr High",
        numberOfStudents: 1089,
        grades: "7-9",
      },
      {
        schoolName: "Muir School",
        numberOfStudents: 670,
        grades: "KG-6",
      },
      {
        schoolName: "North Davis Jr High",
        numberOfStudents: 924,
        grades: "7-9",
      },
      {
        schoolName: "North Layton Jr High",
        numberOfStudents: 1009,
        grades: "7-9",
      },
      {
        schoolName: "Northridge High",
        numberOfStudents: 1954,
        grades: "10-12",
      },
      {
        schoolName: "Oak Hills School",
        numberOfStudents: 404,
        grades: "PK-6",
      },
      {
        schoolName: "Odyssey School",
        numberOfStudents: 603,
        grades: "KG-6",
      },
      {
        schoolName: "Orchard School",
        numberOfStudents: 587,
        grades: "KG-6",
      },
      {
        schoolName: "Parkside School",
        numberOfStudents: 530,
        grades: "PK-6",
      },
      {
        schoolName: "Reading School",
        numberOfStudents: 452,
        grades: "PK-6",
      },
      {
        schoolName: "Ridgeline School",
        numberOfStudents: 762,
        grades: "PK-6",
      },
      {
        schoolName: "Riverview School",
        numberOfStudents: 561,
        grades: "KG-6",
      },
      {
        schoolName: "Rose Creek School",
        numberOfStudents: 410,
        grades: "PK-6",
      },
      {
        schoolName: "Snow Horse School",
        numberOfStudents: 680,
        grades: "KG-6",
      },
      {
        schoolName: "South Clearfield School",
        numberOfStudents: 478,
        grades: "KG-6",
      },
      {
        schoolName: "South Davis Jr High",
        numberOfStudents: 1232,
        grades: "7-9",
      },
      {
        schoolName: "South Weber School",
        numberOfStudents: 501,
        grades: "KG-6",
      },
      {
        schoolName: "Stewart School",
        numberOfStudents: 394,
        grades: "PK-6",
      },
      {
        schoolName: "Sunset Jr High",
        numberOfStudents: 865,
        grades: "7-9",
      },
      {
        schoolName: "Sunset School",
        numberOfStudents: 361,
        grades: "PK-6",
      },
      {
        schoolName: "Syracuse High",
        numberOfStudents: 2227,
        grades: "10-12",
      },
      {
        schoolName: "Syracuse Jr High",
        numberOfStudents: 1314,
        grades: "7-9",
      },
      {
        schoolName: "Syracuse School",
        numberOfStudents: 692,
        grades: "PK-6",
      },
      {
        schoolName: "Tolman School",
        numberOfStudents: 437,
        grades: "PK-6",
      },
      {
        schoolName: "Vae View School",
        numberOfStudents: 453,
        grades: "KG-6",
      },
      {
        schoolName: "Valley View School",
        numberOfStudents: 571,
        grades: "KG-6",
      },
      {
        schoolName: "Viking School",
        numberOfStudents: 432,
        grades: "PK-6",
      },
      {
        schoolName: "Wasatch School",
        numberOfStudents: 380,
        grades: "PK-6",
      },
      {
        schoolName: "West Bountiful School",
        numberOfStudents: 536,
        grades: "KG-6",
      },
      {
        schoolName: "West Clinton School",
        numberOfStudents: 529,
        grades: "KG-6",
      },
      {
        schoolName: "West Davis Jr High",
        numberOfStudents: 0,
        grades: "7-9",
      },
      {
        schoolName: "West Point Jr High",
        numberOfStudents: 1311,
        grades: "7-9",
      },
      {
        schoolName: "West Point School",
        numberOfStudents: 846,
        grades: "KG-6",
      },
      {
        schoolName: "West Weber School",
        numberOfStudents: 376,
        grades: "PK-6",
      },
      {
        schoolName: "Whitesides School",
        numberOfStudents: 467,
        grades: "PK-6",
      },
      {
        schoolName: "Windridge School",
        numberOfStudents: 653,
        grades: "PK-6",
      },
      {
        schoolName: "Woods Cross High",
        numberOfStudents: 1449,
        grades: "10-12",
      },
      {
        schoolName: "Woods Cross School",
        numberOfStudents: 500,
        grades: "PK-6",
      },
      {
        schoolName: "Woodstock School",
        numberOfStudents: 399,
        grades: "PK-6",
      },
    ],
  },
  duchesne: {
    districtName: "Duchesne",
    schools: [
      {
        schoolName: "Altamont High",
        numberOfStudents: 254,
        grades: "7-12",
      },
      {
        schoolName: "Altamont School",
        numberOfStudents: 359,
        grades: "PK-6",
      },
      {
        schoolName: "Basin Online School",
        numberOfStudents: 54,
        grades: "KG-12",
      },
      {
        schoolName: "Centennial School",
        numberOfStudents: 524,
        grades: "KG-5",
      },
      {
        schoolName: "Con Amore School",
        numberOfStudents: 68,
        grades: "PK-12",
      },
      {
        schoolName: "Duchesne High",
        numberOfStudents: 396,
        grades: "7-12",
      },
      {
        schoolName: "Duchesne School",
        numberOfStudents: 442,
        grades: "PK-6",
      },
      {
        schoolName: "East School",
        numberOfStudents: 439,
        grades: "PK-5",
      },
      {
        schoolName: "Kings Peak School",
        numberOfStudents: 462,
        grades: "KG-5",
      },
      {
        schoolName: "Myton School",
        numberOfStudents: 122,
        grades: "KG-5",
      },
      {
        schoolName: "Neola School",
        numberOfStudents: 148,
        grades: "KG-5",
      },
      {
        schoolName: "Roosevelt Jr High",
        numberOfStudents: 829,
        grades: "6-8",
      },
      {
        schoolName: "Tabiona High",
        numberOfStudents: 72,
        grades: "7-12",
      },
      {
        schoolName: "Tabiona School",
        numberOfStudents: 113,
        grades: "KG-6",
      },
      {
        schoolName: "Union High",
        numberOfStudents: 1153,
        grades: "9-12",
      },
    ],
  },
  emery: {
    districtName: "Emery",
    schools: [
      {
        schoolName: "Book Cliff School",
        numberOfStudents: 140,
        grades: "PK-6",
      },
      {
        schoolName: "Canyon View Middle School",
        numberOfStudents: 200,
        grades: "6-8",
      },
      {
        schoolName: "Castle Dale School",
        numberOfStudents: 145,
        grades: "KG-5",
      },
      {
        schoolName: "Cleveland School",
        numberOfStudents: 181,
        grades: "PK-5",
      },
      {
        schoolName: "Cottonwood School",
        numberOfStudents: 159,
        grades: "PK-5",
      },
      {
        schoolName: "Emery High",
        numberOfStudents: 642,
        grades: "9-12",
      },
      {
        schoolName: "Ferron School",
        numberOfStudents: 212,
        grades: "PK-5",
      },
      {
        schoolName: "Green River High",
        numberOfStudents: 70,
        grades: "7-12",
      },
      {
        schoolName: "Huntington School",
        numberOfStudents: 239,
        grades: "PK-5",
      },
      {
        schoolName: "San Rafael Middle School",
        numberOfStudents: 242,
        grades: "6-8",
      },
    ],
  },
  garfield: {
    districtName: "Garfield",
    schools: [
      {
        schoolName: "Antimony School",
        numberOfStudents: 15,
        grades: "PK-6",
      },
      {
        schoolName: "Boulder School",
        numberOfStudents: 17,
        grades: "PK-6",
      },
      {
        schoolName: "Bryce Valley High",
        numberOfStudents: 134,
        grades: "7-12",
      },
      {
        schoolName: "Bryce Valley School",
        numberOfStudents: 167,
        grades: "PK-6",
      },
      {
        schoolName: "Escalante High",
        numberOfStudents: 74,
        grades: "7-12",
      },
      {
        schoolName: "Escalante School",
        numberOfStudents: 107,
        grades: "PK-6",
      },
      {
        schoolName: "Garfield Online",
        numberOfStudents: 329,
        grades: "KG-6",
      },
      {
        schoolName: "Panguitch High",
        numberOfStudents: 159,
        grades: "9-12",
      },
      {
        schoolName: "Panguitch Middle",
        numberOfStudents: 72,
        grades: "7-8",
      },
      {
        schoolName: "Panguitch School",
        numberOfStudents: 238,
        grades: "PK-6",
      },
    ],
  },
  grand: {
    districtName: "Grand County",
    schools: [
      {
        schoolName: "C R Sundwall Center",
        numberOfStudents: 42,
        grades: "PK-PK",
      },
      {
        schoolName: "Grand County High",
        numberOfStudents: 461,
        grades: "9-12",
      },
      {
        schoolName: "Grand County Middle",
        numberOfStudents: 238,
        grades: "7-8",
      },
      {
        schoolName: "Helen M. Knight School",
        numberOfStudents: 732,
        grades: "KG-6",
      },
    ],
  },
  granite: {
    districtName: "Granite",
    schools: [
      {
        schoolName: "Academy Park School",
        numberOfStudents: 370,
        grades: "PK-6",
      },
      { schoolName: "Arcadia School", numberOfStudents: 447, grades: "PK-6" },
      { schoolName: "Beehive School", numberOfStudents: 435, grades: "PK-6" },
      { schoolName: "Bennion Jr High", numberOfStudents: 1000, grades: "6-9" },
      { schoolName: "Bennion School", numberOfStudents: 453, grades: "PK-6" },
      {
        schoolName: "Bonneville Jr High",
        numberOfStudents: 604,
        grades: "6-8",
      },
      {
        schoolName: "Calvin S. Smith School",
        numberOfStudents: 603,
        grades: "PK-6",
      },
      { schoolName: "Churchill Jr High", numberOfStudents: 556, grades: "6-8" },
      {
        schoolName: "Copper Hills School",
        numberOfStudents: 479,
        grades: "PK-6",
      },
      { schoolName: "Cottonwood High", numberOfStudents: 1585, grades: "9-12" },
      {
        schoolName: "Cottonwood School",
        numberOfStudents: 387,
        grades: "PK-6",
      },
      { schoolName: "Crestview School", numberOfStudents: 473, grades: "PK-6" },
      { schoolName: "Cyprus High", numberOfStudents: 2709, grades: "9-12" },
      {
        schoolName: "David Gourley School",
        numberOfStudents: 477,
        grades: "PK-6",
      },
      {
        schoolName: "Diamond Ridge School",
        numberOfStudents: 574,
        grades: "KG-6",
      },
      {
        schoolName: "Douglas T. Orchard School",
        numberOfStudents: 461,
        grades: "PK-6",
      },
      { schoolName: "Eastwood School", numberOfStudents: 332, grades: "PK-5" },
      {
        schoolName: "Eisenhower Jr High",
        numberOfStudents: 1091,
        grades: "6-9",
      },
      {
        schoolName: "Elk Run Elementary",
        numberOfStudents: 629,
        grades: "PK-6",
      },
      { schoolName: "Evergreen Jr High", numberOfStudents: 651, grades: "6-9" },
      { schoolName: "Fox Hills School", numberOfStudents: 570, grades: "KG-6" },
      {
        schoolName: "Gearld Wright School",
        numberOfStudents: 526,
        grades: "PK-6",
      },
      { schoolName: "Granger High", numberOfStudents: 3481, grades: "8-12" },
      { schoolName: "Granger School", numberOfStudents: 755, grades: "PK-6" },
      {
        schoolName: "Granite Connection High",
        numberOfStudents: 482,
        grades: "KG-12",
      },
      {
        schoolName: "Granite Park Jr High",
        numberOfStudents: 871,
        grades: "6-8",
      },
      { schoolName: "Granite Preschool", numberOfStudents: 0, grades: "PK-PK" },
      {
        schoolName: "Granite Technical Institute",
        numberOfStudents: 126,
        grades: "7-12",
      },
      {
        schoolName: "Harry S. Truman School",
        numberOfStudents: 367,
        grades: "PK-6",
      },
      { schoolName: "Hartvigsen School", numberOfStudents: 72, grades: "KG-8" },
      {
        schoolName: "Headstart Preschool Special Education",
        numberOfStudents: 6,
        grades: "PK-KG",
      },
      { schoolName: "Hillsdale School", numberOfStudents: 633, grades: "PK-6" },
      { schoolName: "Hillside School", numberOfStudents: 499, grades: "PK-6" },

      {
        schoolName: "Howard R. Driggs School",
        numberOfStudents: 466,
        grades: "PK-6",
      },
      { schoolName: "Hunter High", numberOfStudents: 2595, grades: "9-12" },
      { schoolName: "Hunter Jr High", numberOfStudents: 732, grades: "7-8" },
      { schoolName: "Hunter School", numberOfStudents: 490, grades: "PK-6" },
      { schoolName: "Jackling School", numberOfStudents: 461, grades: "PK-6" },
      {
        schoolName: "James E. Moss School",
        numberOfStudents: 506,
        grades: "PK-6",
      },
      {
        schoolName: "Jim Bridger School",
        numberOfStudents: 369,
        grades: "PK-6",
      },
      {
        schoolName: "John C. Fremont School",
        numberOfStudents: 379,
        grades: "PK-6",
      },
      {
        schoolName: "John F. Kennedy Jr High",
        numberOfStudents: 857,
        grades: "6-8",
      },
      { schoolName: "Kearns High", numberOfStudents: 2382, grades: "9-12" },
      { schoolName: "Kearns Jr High", numberOfStudents: 778, grades: "6-8" },
      {
        schoolName: "Lake Ridge School",
        numberOfStudents: 422,
        grades: "PK-6",
      },
      { schoolName: "Lincoln School", numberOfStudents: 456, grades: "PK-6" },
      { schoolName: "Magna School", numberOfStudents: 583, grades: "PK-6" },
      {
        schoolName: "Mill Creek School",
        numberOfStudents: 352,
        grades: "PK-6",
      },
      { schoolName: "Monroe School", numberOfStudents: 563, grades: "PK-6" },
      {
        schoolName: "Morningside School",
        numberOfStudents: 573,
        grades: "KG-6",
      },
      {
        schoolName: "Neil Armstrong Academy",
        numberOfStudents: 744,
        grades: "PK-6",
      },
      { schoolName: "Oakridge School", numberOfStudents: 313, grades: "KG-5" },
      { schoolName: "Oakwood School", numberOfStudents: 349, grades: "PK-6" },
      {
        schoolName: "Olene Walker Elementary",
        numberOfStudents: 453,
        grades: "PK-6",
      },
      { schoolName: "Olympus High", numberOfStudents: 2123, grades: "9-12" },
      { schoolName: "Olympus Jr High", numberOfStudents: 784, grades: "5-9" },
      {
        schoolName: "Philo T. Farnsworth School",
        numberOfStudents: 546,
        grades: "PK-6",
      },
      { schoolName: "Pioneer School", numberOfStudents: 478, grades: "PK-6" },
      {
        schoolName: "Pleasant Green School",
        numberOfStudents: 445,
        grades: "PK-6",
      },
      { schoolName: "Plymouth School", numberOfStudents: 562, grades: "PK-6" },
      { schoolName: "Redwood School", numberOfStudents: 486, grades: "PK-6" },
      {
        schoolName: "Robert Frost School",
        numberOfStudents: 355,
        grades: "PK-6",
      },
      {
        schoolName: "Rolling Meadows School",
        numberOfStudents: 472,
        grades: "PK-6",
      },
      { schoolName: "Rosecrest School", numberOfStudents: 327, grades: "PK-6" },
      {
        schoolName: "Scott M Matheson Jr High",
        numberOfStudents: 1081,
        grades: "7-8",
      },
      {
        schoolName: "Silver Hills School",
        numberOfStudents: 385,
        grades: "PK-6",
      },
      { schoolName: "Skyline High", numberOfStudents: 2124, grades: "7-12" },
      {
        schoolName: "South Kearns School",
        numberOfStudents: 449,
        grades: "PK-6",
      },
      {
        schoolName: "Spring Lane School",
        numberOfStudents: 298,
        grades: "PK-6",
      },
      { schoolName: "Stansbury School", numberOfStudents: 623, grades: "PK-6" },
      {
        schoolName: "Taylorsville High",
        numberOfStudents: 2770,
        grades: "9-12",
      },
      {
        schoolName: "Taylorsville School",
        numberOfStudents: 381,
        grades: "PK-6",
      },
      {
        schoolName: "Thomas Jefferson Jr High",
        numberOfStudents: 989,
        grades: "6-8",
      },
      {
        schoolName: "Thomas W. Bacchus School",
        numberOfStudents: 335,
        grades: "KG-6",
      },
      {
        schoolName: "Twin Peaks School",
        numberOfStudents: 270,
        grades: "PK-6",
      },
      {
        schoolName: "Upland Terrace School",
        numberOfStudents: 520,
        grades: "PK-5",
      },
      {
        schoolName: "Valley Crest School",
        numberOfStudents: 494,
        grades: "PK-6",
      },
      { schoolName: "Valley Jr High", numberOfStudents: 639, grades: "7-8" },
      { schoolName: "Vista School", numberOfStudents: 517, grades: "PK-9" },
      { schoolName: "Wasatch Jr High", numberOfStudents: 787, grades: "6-8" },
      {
        schoolName: "Western Hills School",
        numberOfStudents: 300,
        grades: "PK-6",
      },
      {
        schoolName: "West Kearns School",
        numberOfStudents: 578,
        grades: "PK-6",
      },
      { schoolName: "West Lake Jr High", numberOfStudents: 701, grades: "7-8" },
      {
        schoolName: "West Valley School",
        numberOfStudents: 735,
        grades: "PK-6",
      },
      { schoolName: "Whittier School", numberOfStudents: 499, grades: "PK-6" },
      {
        schoolName: "William Penn School",
        numberOfStudents: 523,
        grades: "KG-6",
      },
      {
        schoolName: "Woodrow Wilson School",
        numberOfStudents: 461,
        grades: "PK-6",
      },
      { schoolName: "Woodstock School", numberOfStudents: 559, grades: "PK-6" },
      {
        schoolName: "Youth Educational Support School",
        numberOfStudents: 74,
        grades: "KG-12",
      },
    ],
  },
  iron: {
    districtName: "Iron County",
    schools: [
      {
        schoolName: "Canyon View High",
        numberOfStudents: 1123,
        grades: "9-12",
      },
      {
        schoolName: "Canyon View Middle",
        numberOfStudents: 989,
        grades: "6-8",
      },
      { schoolName: "Cedar City High", numberOfStudents: 1366, grades: "9-12" },
      {
        schoolName: "Cedar East School",
        numberOfStudents: 551,
        grades: "KG-5",
      },
      { schoolName: "Cedar Middle", numberOfStudents: 1115, grades: "6-8" },
      {
        schoolName: "Cedar North School",
        numberOfStudents: 636,
        grades: "KG-5",
      },
      {
        schoolName: "Cedar South School",
        numberOfStudents: 565,
        grades: "KG-5",
      },
      { schoolName: "Enoch School", numberOfStudents: 593, grades: "KG-5" },
      {
        schoolName: "Escalante Valley School",
        numberOfStudents: 122,
        grades: "PK-6",
      },
      {
        schoolName: "Fiddlers Canyon School",
        numberOfStudents: 544,
        grades: "KG-5",
      },
      {
        schoolName: "Iron County Preschool",
        numberOfStudents: 189,
        grades: "PK-PK",
      },
      {
        schoolName: "Iron Springs School",
        numberOfStudents: 619,
        grades: "KG-5",
      },
      { schoolName: "Launch High", numberOfStudents: 195, grades: "9-12" },
      { schoolName: "Parowan High", numberOfStudents: 363, grades: "7-12" },
      { schoolName: "Parowan School", numberOfStudents: 420, grades: "KG-6" },
      {
        schoolName: "Southwest Educational Academy",
        numberOfStudents: 2585,
        grades: "KG-12",
      },
      {
        schoolName: "Three Peaks Pre School",
        numberOfStudents: 121,
        grades: "PK-PK",
      },
      {
        schoolName: "Three Peaks School",
        numberOfStudents: 643,
        grades: "KG-5",
      },
    ],
  },
  jordan: {
    districtName: "Jordan",
    schools: [
      {
        schoolName: "Antelope Canyon Elementary",
        numberOfStudents: 612,
        grades: "KG-6",
      },
      { schoolName: "Aspen Elementary", numberOfStudents: 642, grades: "KG-6" },
      { schoolName: "Bastian School", numberOfStudents: 714, grades: "KG-6" },
      { schoolName: "Bingham High", numberOfStudents: 2482, grades: "10-12" },
      {
        schoolName: "Blackridge School",
        numberOfStudents: 941,
        grades: "KG-6",
      },
      { schoolName: "Bluffdale School", numberOfStudents: 754, grades: "KG-6" },
      {
        schoolName: "Butterfield Canyon School",
        numberOfStudents: 774,
        grades: "KG-6",
      },
      { schoolName: "Columbia School", numberOfStudents: 619, grades: "KG-6" },
      {
        schoolName: "Copper Canyon School",
        numberOfStudents: 569,
        grades: "KG-6",
      },
      {
        schoolName: "Copper Hills High",
        numberOfStudents: 2841,
        grades: "10-12",
      },
      {
        schoolName: "Copper Mountain Middle",
        numberOfStudents: 1085,
        grades: "7-9",
      },
      { schoolName: "Daybreak School", numberOfStudents: 777, grades: "KG-6" },
      { schoolName: "Eastlake School", numberOfStudents: 885, grades: "KG-6" },
      {
        schoolName: "Elk Meadows School",
        numberOfStudents: 666,
        grades: "KG-6",
      },
      { schoolName: "Elk Ridge Middle", numberOfStudents: 1118, grades: "7-9" },
      {
        schoolName: "Falcon Ridge School",
        numberOfStudents: 654,
        grades: "KG-6",
      },
      { schoolName: "Foothills School", numberOfStudents: 919, grades: "KG-6" },
      {
        schoolName: "Fort Herriman Middle",
        numberOfStudents: 1261,
        grades: "7-9",
      },
      {
        schoolName: "Fox Hollow School",
        numberOfStudents: 935,
        grades: "KG-6",
      },
      {
        schoolName: "Golden Fields School",
        numberOfStudents: 882,
        grades: "KG-6",
      },
      {
        schoolName: "Hayden Peak School",
        numberOfStudents: 723,
        grades: "KG-6",
      },
      { schoolName: "Heartland School", numberOfStudents: 438, grades: "KG-6" },
      { schoolName: "Herriman High", numberOfStudents: 2240, grades: "10-12" },
      { schoolName: "Herriman School", numberOfStudents: 731, grades: "KG-6" },
      {
        schoolName: "Hidden Valley Middle",
        numberOfStudents: 868,
        grades: "7-9",
      },
      {
        schoolName: "Joel P. Jensen Middle",
        numberOfStudents: 801,
        grades: "7-9",
      },
      {
        schoolName: "Jordan Academy For Technology And Careers - North",
        numberOfStudents: 0,
        grades: "9-12",
      },
      {
        schoolName: "Jordan Academy For Technology & Careers South",
        numberOfStudents: 0,
        grades: "10-12",
      },
      {
        schoolName: "Jordan Hills School",
        numberOfStudents: 665,
        grades: "KG-6",
      },
      {
        schoolName: "Jordan Ridge School",
        numberOfStudents: 676,
        grades: "KG-6",
      },
      {
        schoolName: "Kauri Sue Hamilton",
        numberOfStudents: 236,
        grades: "KG-12",
      },
      {
        schoolName: "Kelsey Peak Virtual Middle",
        numberOfStudents: 120,
        grades: "7-8",
      },
      { schoolName: "Kings Peak High", numberOfStudents: 256, grades: "9-12" },
      { schoolName: "Majestic School", numberOfStudents: 257, grades: "KG-6" },
      {
        schoolName: "Midas Creek School",
        numberOfStudents: 805,
        grades: "KG-6",
      },
      {
        schoolName: "Monte Vista School",
        numberOfStudents: 833,
        grades: "KG-6",
      },
      {
        schoolName: "Mountain Creek Middle School",
        numberOfStudents: 1275,
        grades: "7-9",
      },
      {
        schoolName: "Mountain Point Elementary",
        numberOfStudents: 773,
        grades: "KG-6",
      },
      {
        schoolName: "Mountain Ridge High",
        numberOfStudents: 2507,
        grades: "10-12",
      },
      {
        schoolName: "Mountain Shadows School",
        numberOfStudents: 585,
        grades: "KG-6",
      },
      { schoolName: "Oakcrest School", numberOfStudents: 662, grades: "KG-6" },
      {
        schoolName: "Oak Leaf Elementary",
        numberOfStudents: 500,
        grades: "KG-6",
      },
      {
        schoolName: "Oquirrh Hills Middle",
        numberOfStudents: 1332,
        grades: "7-9",
      },
      { schoolName: "Oquirrh School", numberOfStudents: 458, grades: "KG-6" },
      { schoolName: "Preschool", numberOfStudents: 1618, grades: "PK-PK" },
      {
        schoolName: "Ridge View Elementary",
        numberOfStudents: 1092,
        grades: "KG-6",
      },
      {
        schoolName: "Rivers Edge School",
        numberOfStudents: 10,
        grades: "KG-8",
      },
      { schoolName: "Riverside School", numberOfStudents: 622, grades: "KG-6" },
      { schoolName: "Riverton High", numberOfStudents: 2286, grades: "10-12" },
      { schoolName: "Riverton School", numberOfStudents: 694, grades: "KG-6" },
      {
        schoolName: "Rocky Peak Virtual School",
        numberOfStudents: 216,
        grades: "KG-6",
      },
      { schoolName: "Rosamond School", numberOfStudents: 608, grades: "KG-6" },
      {
        schoolName: "Rose Creek School",
        numberOfStudents: 757,
        grades: "KG-6",
      },
      {
        schoolName: "Silver Crest School",
        numberOfStudents: 902,
        grades: "KG-6",
      },
      {
        schoolName: "South Hills Middle",
        numberOfStudents: 1091,
        grades: "7-9",
      },
      {
        schoolName: "South Jordan Middle",
        numberOfStudents: 1249,
        grades: "7-9",
      },
      {
        schoolName: "South Jordan School",
        numberOfStudents: 882,
        grades: "KG-6",
      },
      { schoolName: "Southland School", numberOfStudents: 681, grades: "KG-6" },
      {
        schoolName: "Southpointe Adult High",
        numberOfStudents: 0,
        grades: "9-12",
      },
      {
        schoolName: "South Valley School",
        numberOfStudents: 150,
        grades: "9-12",
      },
      {
        schoolName: "Sunset Ridge Middle",
        numberOfStudents: 1454,
        grades: "7-9",
      },
      {
        schoolName: "Terra Linda School",
        numberOfStudents: 474,
        grades: "KG-6",
      },
      {
        schoolName: "Valley High School",
        numberOfStudents: 363,
        grades: "7-12",
      },
      { schoolName: "Welby School", numberOfStudents: 790, grades: "KG-6" },
      {
        schoolName: "West Hills Middle",
        numberOfStudents: 1247,
        grades: "7-9",
      },
      {
        schoolName: "West Jordan High",
        numberOfStudents: 1826,
        grades: "10-12",
      },
      {
        schoolName: "West Jordan Middle",
        numberOfStudents: 1104,
        grades: "7-9",
      },
      {
        schoolName: "West Jordan School",
        numberOfStudents: 456,
        grades: "KG-6",
      },
      { schoolName: "Westland School", numberOfStudents: 488, grades: "KG-6" },
      { schoolName: "Westvale School", numberOfStudents: 490, grades: "KG-6" },
    ],
  },
  juab: {
    districtName: "Juab",
    schools: [
      {
        schoolName: "Arizona State University Prep Digital Powered By Juab",
        numberOfStudents: 0,
        grades: "6-12",
      },
      { schoolName: "Juab High", numberOfStudents: 890, grades: "9-12" },
      { schoolName: "Juab Jr High", numberOfStudents: 639, grades: "6-8" },
      { schoolName: "Mona School", numberOfStudents: 294, grades: "KG-6" },
      { schoolName: "Nebo View School", numberOfStudents: 306, grades: "KG-6" },
      { schoolName: "Red Cliff School", numberOfStudents: 602, grades: "PK-6" },
    ],
  },
  kane: {
    districtName: "Kane",
    schools: [
      { schoolName: "Big Water High", numberOfStudents: 34, grades: "7-12" },
      { schoolName: "Big Water School", numberOfStudents: 43, grades: "KG-6" },
      { schoolName: "Kanab High", numberOfStudents: 317, grades: "9-12" },
      { schoolName: "Kanab Middle", numberOfStudents: 176, grades: "7-8" },
      { schoolName: "Kanab School", numberOfStudents: 526, grades: "KG-6" },
      { schoolName: "Kane Preschool", numberOfStudents: 93, grades: "PK-PK" },
      {
        schoolName: "Lake Powell High School",
        numberOfStudents: 4,
        grades: "7-12",
      },
      { schoolName: "Lake Powell School", numberOfStudents: 9, grades: "KG-6" },
      { schoolName: "Valley High", numberOfStudents: 150, grades: "7-12" },
      { schoolName: "Valley School", numberOfStudents: 167, grades: "KG-6" },
    ],
  },
  logan: {
    districtName: "Logan",
    schools: [
      { schoolName: "Adams School", numberOfStudents: 296, grades: "PK-5" },
      { schoolName: "Bridger School", numberOfStudents: 490, grades: "PK-5" },
      { schoolName: "Ellis School", numberOfStudents: 370, grades: "PK-5" },
      { schoolName: "Hillcrest School", numberOfStudents: 495, grades: "KG-5" },
      {
        schoolName: "Lcsd Center For Home Learning",
        numberOfStudents: 0,
        grades: "KG-8",
      },
      {
        schoolName: "Logan Early Childhood Center",
        numberOfStudents: 84,
        grades: "PK-PK",
      },
      { schoolName: "Logan High", numberOfStudents: 1456, grades: "9-12" },
      {
        schoolName: "Mount Logan Middle",
        numberOfStudents: 1157,
        grades: "6-8",
      },
      {
        schoolName: "Riverside Preschool",
        numberOfStudents: 63,
        grades: "PK-PK",
      },
      { schoolName: "Wilson School", numberOfStudents: 384, grades: "KG-5" },
      { schoolName: "Woodruff School", numberOfStudents: 625, grades: "PK-5" },
    ],
  },
  millard: {
    districtName: "Millard",
    schools: [
      { schoolName: "Delta High", numberOfStudents: 561, grades: "9-12" },
      { schoolName: "Delta Middle", numberOfStudents: 591, grades: "5-8" },
      {
        schoolName: "Delta North School",
        numberOfStudents: 467,
        grades: "2-4",
      },
      {
        schoolName: "Delta South School",
        numberOfStudents: 361,
        grades: "PK-1",
      },
      { schoolName: "Eskdale High", numberOfStudents: 23, grades: "7-12" },
      { schoolName: "Fillmore Middle", numberOfStudents: 356, grades: "5-8" },
      { schoolName: "Fillmore School", numberOfStudents: 475, grades: "PK-4" },
      { schoolName: "Garrison School", numberOfStudents: 24, grades: "KG-6" },
      { schoolName: "Millard High", numberOfStudents: 406, grades: "9-12" },
    ],
  },
  morgan: {
    districtName: "Morgan",
    schools: [
      { schoolName: "Morgan High", numberOfStudents: 1129, grades: "9-12" },
      { schoolName: "Morgan Middle", numberOfStudents: 534, grades: "5-8" },
      { schoolName: "Morgan Online", numberOfStudents: 23, grades: "KG-12" },
      { schoolName: "Morgan Preschool", numberOfStudents: 32, grades: "PK-PK" },
      { schoolName: "Morgan School", numberOfStudents: 568, grades: "KG-4" },
      {
        schoolName: "Mountain Green Middle",
        numberOfStudents: 528,
        grades: "5-8",
      },
      {
        schoolName: "Mountain Green Preschool",
        numberOfStudents: 26,
        grades: "PK-PK",
      },
      {
        schoolName: "Mountain Green School",
        numberOfStudents: 499,
        grades: "KG-4",
      },
    ],
  },
  murray: {
    districtName: "Murray",
    schools: [
      {
        schoolName: "Early Childhood Center",
        numberOfStudents: 106,
        grades: "PK-PK",
      },
      { schoolName: "Grant School", numberOfStudents: 338, grades: "KG-6" },
      { schoolName: "Hillcrest Jr High", numberOfStudents: 776, grades: "7-9" },
      { schoolName: "Horizon School", numberOfStudents: 590, grades: "KG-6" },
      { schoolName: "Liberty School", numberOfStudents: 291, grades: "KG-6" },
      { schoolName: "Longview School", numberOfStudents: 338, grades: "KG-6" },
      { schoolName: "Mcmillan School", numberOfStudents: 481, grades: "KG-6" },
      {
        schoolName: "Murray Adult Transition",
        numberOfStudents: 0,
        grades: "9-12",
      },
      { schoolName: "Murray High", numberOfStudents: 1400, grades: "10-12" },
      { schoolName: "Parkside School", numberOfStudents: 471, grades: "KG-6" },
      { schoolName: "Riverview Jr High", numberOfStudents: 618, grades: "7-9" },
      { schoolName: "Viewmont School", numberOfStudents: 462, grades: "KG-6" },
    ],
  },
  nebo: {
    districtName: "Nebo",
    schools: [
      {
        schoolName: "Apple Valley School",
        numberOfStudents: 653,
        grades: "PK-6",
      },
      { schoolName: "Art City School", numberOfStudents: 460, grades: "PK-6" },
      { schoolName: "Barnett School", numberOfStudents: 413, grades: "PK-6" },
      {
        schoolName: "Bridges Nebo Transition Center",
        numberOfStudents: 141,
        grades: "PK-12",
      },
      { schoolName: "Brockbank School", numberOfStudents: 505, grades: "PK-6" },
      { schoolName: "Brookside School", numberOfStudents: 393, grades: "PK-6" },
      { schoolName: "Canyon School", numberOfStudents: 495, grades: "PK-6" },
      {
        schoolName: "Cherry Creek School",
        numberOfStudents: 505,
        grades: "PK-6",
      },
      {
        schoolName: "Diamond Fork Middle",
        numberOfStudents: 1039,
        grades: "6-8",
      },
      {
        schoolName: "East Meadows School",
        numberOfStudents: 584,
        grades: "PK-6",
      },
      { schoolName: "Foothills School", numberOfStudents: 723, grades: "PK-6" },
      { schoolName: "Goshen School", numberOfStudents: 288, grades: "PK-6" },
      {
        schoolName: "Hobble Creek School",
        numberOfStudents: 459,
        grades: "PK-6",
      },
      { schoolName: "Landmark High", numberOfStudents: 342, grades: "KG-12" },
      { schoolName: "Larsen School", numberOfStudents: 371, grades: "PK-6" },
      {
        schoolName: "Maple Grove Middle",
        numberOfStudents: 1210,
        grades: "6-8",
      },
      {
        schoolName: "Maple Mountain High",
        numberOfStudents: 1740,
        grades: "7-12",
      },
      {
        schoolName: "Maple Ridge School",
        numberOfStudents: 769,
        grades: "PK-6",
      },
      {
        schoolName: "Mapleton Junior High",
        numberOfStudents: 1213,
        grades: "7-9",
      },
      { schoolName: "Mapleton School", numberOfStudents: 589, grades: "PK-6" },
      {
        schoolName: "Meadow Brook School",
        numberOfStudents: 691,
        grades: "PK-6",
      },
      {
        schoolName: "Mt. Loafer School",
        numberOfStudents: 622,
        grades: "PK-6",
      },
      { schoolName: "Mt. Nebo Middle", numberOfStudents: 1113, grades: "6-7" },
      {
        schoolName: "Nebo Advanced Learning Center",
        numberOfStudents: 2,
        grades: "KG-12",
      },
      {
        schoolName: "Nebo Online School",
        numberOfStudents: 1736,
        grades: "KG-12",
      },
      {
        schoolName: "Orchard Hills School",
        numberOfStudents: 572,
        grades: "PK-6",
      },
      { schoolName: "Park School", numberOfStudents: 417, grades: "PK-6" },
      { schoolName: "Park View School", numberOfStudents: 358, grades: "PK-6" },
      { schoolName: "Payson High", numberOfStudents: 1554, grades: "6-12" },
      { schoolName: "Payson Jr High", numberOfStudents: 1135, grades: "7-9" },
      { schoolName: "Rees School", numberOfStudents: 641, grades: "PK-6" },
      { schoolName: "Riverview School", numberOfStudents: 708, grades: "PK-6" },
      {
        schoolName: "Sage Creek School",
        numberOfStudents: 541,
        grades: "PK-6",
      },
      {
        schoolName: "Salem Hills High",
        numberOfStudents: 1561,
        grades: "9-12",
      },
      { schoolName: "Salem Junior High", numberOfStudents: 993, grades: "7-9" },
      { schoolName: "Salem School", numberOfStudents: 501, grades: "PK-6" },
      { schoolName: "Santaquin School", numberOfStudents: 623, grades: "PK-6" },
      {
        schoolName: "Sierra Bonita Elementary",
        numberOfStudents: 623,
        grades: "PK-6",
      },
      {
        schoolName: "Spanish Fork High",
        numberOfStudents: 1519,
        grades: "9-12",
      },
      {
        schoolName: "Spanish Fork Jr High",
        numberOfStudents: 1103,
        grades: "7-9",
      },
      {
        schoolName: "Spanish Oaks School",
        numberOfStudents: 429,
        grades: "PK-6",
      },
      {
        schoolName: "Spring Canyon Middle",
        numberOfStudents: 1086,
        grades: "6-8",
      },
      {
        schoolName: "Spring Lake School",
        numberOfStudents: 584,
        grades: "PK-6",
      },
      {
        schoolName: "Springville High",
        numberOfStudents: 1612,
        grades: "8-12",
      },
      {
        schoolName: "Springville Jr High",
        numberOfStudents: 1168,
        grades: "7-9",
      },
      { schoolName: "Taylor School", numberOfStudents: 455, grades: "PK-6" },
      {
        schoolName: "Valley View Middle",
        numberOfStudents: 894,
        grades: "6-7",
      },
      { schoolName: "Westside School", numberOfStudents: 580, grades: "PK-6" },
      { schoolName: "Wilson School", numberOfStudents: 331, grades: "PK-6" },
    ],
  },
  sanpete: {
    districtName: "North Sanpete",
    schools: [
      { schoolName: "Fairview School", numberOfStudents: 244, grades: "KG-6" },
      {
        schoolName: "Fountain Green School",
        numberOfStudents: 174,
        grades: "PK-6",
      },
      { schoolName: "Moroni School", numberOfStudents: 370, grades: "PK-6" },
      {
        schoolName: "Mt. Pleasant School",
        numberOfStudents: 558,
        grades: "PK-6",
      },
      {
        schoolName: "North Sanpete High",
        numberOfStudents: 765,
        grades: "9-12",
      },
      {
        schoolName: "North Sanpete Middle",
        numberOfStudents: 423,
        grades: "7-8",
      },
      {
        schoolName: "Pleasant Creek High School",
        numberOfStudents: 112,
        grades: "KG-12",
      },
      {
        schoolName: "Spring City School",
        numberOfStudents: 106,
        grades: "KG-6",
      },
    ],
  },
  summit: {
    districtName: "North Summit",
    schools: [
      {
        schoolName: "North Summit High",
        numberOfStudents: 328,
        grades: "9-12",
      },
      {
        schoolName: "North Summit Middle",
        numberOfStudents: 334,
        grades: "5-8",
      },
      {
        schoolName: "North Summit Preschool",
        numberOfStudents: 27,
        grades: "PK-PK",
      },
      {
        schoolName: "North Summit School",
        numberOfStudents: 364,
        grades: "KG-4",
      },
    ],
  },
  ogden: {
    districtName: "Ogden",
    schools: [
      {
        schoolName: "Ben Lomond High",
        numberOfStudents: 1169,
        grades: "10-12",
      },
      {
        schoolName: "Bonneville School",
        numberOfStudents: 251,
        grades: "PK-6",
      },
      {
        schoolName: "Contracted Special Education",
        numberOfStudents: 0,
        grades: "KG-12",
      },
      {
        schoolName: "East Ridge Elementary School",
        numberOfStudents: 720,
        grades: "PK-6",
      },
      {
        schoolName: "George Washington High",
        numberOfStudents: 238,
        grades: "7-12",
      },
      { schoolName: "Heritage School", numberOfStudents: 638, grades: "KG-6" },
      {
        schoolName: "Highland Junior High",
        numberOfStudents: 715,
        grades: "7-9",
      },
      { schoolName: "Hillcrest School", numberOfStudents: 336, grades: "PK-6" },
      {
        schoolName: "James Madison School",
        numberOfStudents: 321,
        grades: "PK-6",
      },
      {
        schoolName: "Liberty Elementary School",
        numberOfStudents: 419,
        grades: "PK-6",
      },
      { schoolName: "Lincoln School", numberOfStudents: 461, grades: "PK-6" },
      {
        schoolName: "Malan'S Peak Secondary",
        numberOfStudents: 38,
        grades: "7-12",
      },
      {
        schoolName: "Mound Fort Junior High",
        numberOfStudents: 627,
        grades: "7-9",
      },
      {
        schoolName: "Mount Ogden Junior High",
        numberOfStudents: 858,
        grades: "7-9",
      },
      {
        schoolName: "New Bridge School",
        numberOfStudents: 614,
        grades: "PK-6",
      },
      { schoolName: "Odyssey School", numberOfStudents: 448, grades: "PK-6" },
      { schoolName: "Ogden High", numberOfStudents: 1128, grades: "10-12" },
      {
        schoolName: "Ogden Online Elementary",
        numberOfStudents: 0,
        grades: "KG-6",
      },
      {
        schoolName: "Ogden Online Secondary",
        numberOfStudents: 0,
        grades: "7-12",
      },
      { schoolName: "Ogden Preschool", numberOfStudents: 163, grades: "PK-KG" },
      { schoolName: "Polk School", numberOfStudents: 439, grades: "KG-6" },
      {
        schoolName: "Shadow Valley School",
        numberOfStudents: 587,
        grades: "KG-6",
      },
      { schoolName: "Spec. Educ. Atc", numberOfStudents: 0, grades: "PK-12" },
      { schoolName: "Wasatch School", numberOfStudents: 351, grades: "KG-6" },
    ],
  },
  park: {
    districtName: "Park City",
    schools: [
      { schoolName: "Ecker Hill Middle", numberOfStudents: 705, grades: "6-7" },
      {
        schoolName: "Jeremy Ranch Preschool",
        numberOfStudents: 49,
        grades: "PK-PK",
      },
      {
        schoolName: "Jeremy Ranch School",
        numberOfStudents: 454,
        grades: "KG-5",
      },
      {
        schoolName: "Mc Polin Preschool",
        numberOfStudents: 0,
        grades: "PK-PK",
      },
      { schoolName: "Mcpolin School", numberOfStudents: 403, grades: "PK-5" },
      { schoolName: "Mpes Preschool", numberOfStudents: 46, grades: "PK-PK" },
      { schoolName: "Park City High", numberOfStudents: 1224, grades: "10-12" },
      {
        schoolName: "Parley'S Park Preschool",
        numberOfStudents: 28,
        grades: "PK-PK",
      },
      {
        schoolName: "Parleys Park School",
        numberOfStudents: 432,
        grades: "KG-5",
      },
      {
        schoolName: "Trailside Preschool",
        numberOfStudents: 28,
        grades: "PK-PK",
      },
      { schoolName: "Trailside School", numberOfStudents: 363, grades: "KG-5" },
      {
        schoolName: "Treasure Mtn. Junior High School",
        numberOfStudents: 772,
        grades: "8-9",
      },
    ],
  },
  piute: {
    districtName: "Piute",
    schools: [
      {
        schoolName: "Circleville Preschool",
        numberOfStudents: 22,
        grades: "PK-PK",
      },
      {
        schoolName: "Circleville School",
        numberOfStudents: 85,
        grades: "KG-8",
      },
      {
        schoolName: "Oscarson Preschool",
        numberOfStudents: 4,
        grades: "PK-PK",
      },
      { schoolName: "Oscarson School", numberOfStudents: 31, grades: "KG-6" },
      { schoolName: "Piute High", numberOfStudents: 144, grades: "7-12" },
    ],
  },
  provo: {
    districtName: "Provo City",
    schools: [
      {
        schoolName: "Amelia Earhart School",
        numberOfStudents: 419,
        grades: "KG-6",
      },
      {
        schoolName: "Canyon Crest School",
        numberOfStudents: 474,
        grades: "KG-6",
      },
      {
        schoolName: "Centennial Middle",
        numberOfStudents: 1094,
        grades: "7-8",
      },
      { schoolName: "Dixon Middle", numberOfStudents: 936, grades: "7-8" },
      { schoolName: "Edgemont School", numberOfStudents: 634, grades: "KG-6" },
      { schoolName: "Franklin School", numberOfStudents: 366, grades: "PK-6" },
      {
        schoolName: "Independence High",
        numberOfStudents: 268,
        grades: "5-12",
      },
      { schoolName: "Lakeview School", numberOfStudents: 695, grades: "KG-6" },
      {
        schoolName: "Oak Springs School",
        numberOfStudents: 41,
        grades: "KG-12",
      },
      {
        schoolName: "Provo Adult Education",
        numberOfStudents: 0,
        grades: "9-12",
      },
      { schoolName: "Provo Eschool", numberOfStudents: 65, grades: "KG-12" },
      { schoolName: "Provo High", numberOfStudents: 1988, grades: "7-12" },
      {
        schoolName: "Provo Peaks School",
        numberOfStudents: 551,
        grades: "KG-6",
      },
      { schoolName: "Provost School", numberOfStudents: 470, grades: "KG-6" },
      {
        schoolName: "Rock Canyon School",
        numberOfStudents: 536,
        grades: "KG-6",
      },
      { schoolName: "Slate Canyon", numberOfStudents: 15, grades: "7-12" },
      {
        schoolName: "Spring Creek School",
        numberOfStudents: 456,
        grades: "PK-6",
      },
      {
        schoolName: "Sunrise Preschool",
        numberOfStudents: 215,
        grades: "PK-PK",
      },
      {
        schoolName: "Sunset View School",
        numberOfStudents: 583,
        grades: "PK-6",
      },
      {
        schoolName: "Timpanogos School",
        numberOfStudents: 627,
        grades: "KG-6",
      },
      { schoolName: "Timpview High", numberOfStudents: 2341, grades: "9-12" },
      { schoolName: "Wasatch School", numberOfStudents: 610, grades: "KG-6" },
      { schoolName: "Westridge School", numberOfStudents: 623, grades: "KG-6" },
    ],
  },
  rich: {
    districtName: "Rich",
    schools: [
      {
        schoolName: "North Rich School",
        numberOfStudents: 113,
        grades: "KG-5",
      },
      { schoolName: "Rich High", numberOfStudents: 156, grades: "9-12" },
      {
        schoolName: "Rich Middle School",
        numberOfStudents: 123,
        grades: "6-8",
      },
      { schoolName: "Rich Preschool", numberOfStudents: 0, grades: "PK-PK" },
      {
        schoolName: "South Rich School",
        numberOfStudents: 121,
        grades: "KG-5",
      },
    ],
  },
  salt: {
    districtName: "Salt Lake City",
    schools: [
      { schoolName: "Backman School", numberOfStudents: 364, grades: "PK-6" },
      {
        schoolName: "Beacon Heights School",
        numberOfStudents: 397,
        grades: "KG-6",
      },
      {
        schoolName: "Bonneville School",
        numberOfStudents: 449,
        grades: "KG-6",
      },
      { schoolName: "Clayton Middle", numberOfStudents: 634, grades: "7-8" },
      { schoolName: "Dilworth School", numberOfStudents: 492, grades: "PK-6" },
      { schoolName: "East High", numberOfStudents: 1886, grades: "9-12" },
      { schoolName: "Edison School", numberOfStudents: 368, grades: "PK-6" },
      { schoolName: "Emerson School", numberOfStudents: 467, grades: "KG-6" },
      { schoolName: "Ensign School", numberOfStudents: 313, grades: "PK-6" },
      { schoolName: "Escalante School", numberOfStudents: 362, grades: "PK-6" },
      { schoolName: "Franklin School", numberOfStudents: 306, grades: "PK-6" },
      { schoolName: "Glendale Middle", numberOfStudents: 680, grades: "6-8" },
      { schoolName: "Hawthorne School", numberOfStudents: 362, grades: "KG-6" },
      { schoolName: "Highland High", numberOfStudents: 1980, grades: "9-12" },
      {
        schoolName: "Highland Park School",
        numberOfStudents: 493,
        grades: "KG-6",
      },
      { schoolName: "Hillside Middle", numberOfStudents: 555, grades: "7-8" },
      {
        schoolName: "Horizonte Instruction & Training Center",
        numberOfStudents: 323,
        grades: "7-12",
      },
      {
        schoolName: "Indian Hills School",
        numberOfStudents: 302,
        grades: "KG-6",
      },
      {
        schoolName: "Innovations High School",
        numberOfStudents: 293,
        grades: "9-12",
      },
      { schoolName: "Liberty School", numberOfStudents: 391, grades: "PK-6" },
      {
        schoolName: "Mary W. Jackson School",
        numberOfStudents: 388,
        grades: "PK-6",
      },
      {
        schoolName: "Meadowlark School",
        numberOfStudents: 354,
        grades: "PK-6",
      },
      {
        schoolName: "M. Lynn Bennion School",
        numberOfStudents: 175,
        grades: "PK-6",
      },
      {
        schoolName: "Mountain View School",
        numberOfStudents: 550,
        grades: "PK-6",
      },
      { schoolName: "Newman School", numberOfStudents: 267, grades: "PK-6" },
      {
        schoolName: "Nibley Park School",
        numberOfStudents: 344,
        grades: "PK-8",
      },
      {
        schoolName: "North Star School",
        numberOfStudents: 386,
        grades: "PK-6",
      },
      { schoolName: "Northwest Middle", numberOfStudents: 633, grades: "7-8" },
      { schoolName: "Parkview School", numberOfStudents: 249, grades: "PK-6" },
      { schoolName: "Riley School", numberOfStudents: 223, grades: "PK-6" },
      { schoolName: "Rose Park School", numberOfStudents: 294, grades: "PK-6" },
      {
        schoolName: "Salt Lake Center For Science Education Bryant",
        numberOfStudents: 407,
        grades: "7-8",
      },
      {
        schoolName: "Salt Lake Head Start",
        numberOfStudents: 18,
        grades: "PK-PK",
      },
      {
        schoolName: "Salt Lake Technology Center",
        numberOfStudents: 0,
        grades: "9-12",
      },
      {
        schoolName: "Salt Lake Virtual Elementary",
        numberOfStudents: 58,
        grades: "KG-8",
      },
      {
        schoolName: "South Park Academy",
        numberOfStudents: 0,
        grades: "12-12",
      },
      { schoolName: "Uintah School", numberOfStudents: 414, grades: "KG-6" },
      { schoolName: "Wasatch School", numberOfStudents: 337, grades: "KG-6" },
      {
        schoolName: "Washington School",
        numberOfStudents: 267,
        grades: "PK-6",
      },
      { schoolName: "West High", numberOfStudents: 2600, grades: "7-12" },
      { schoolName: "Whittier School", numberOfStudents: 499, grades: "PK-6" },
    ],
  },
  san: {
    districtName: "San Juan",
    schools: [
      {
        schoolName: "Albert R. Lyman Middle",
        numberOfStudents: 319,
        grades: "6-8",
      },
      { schoolName: "Blanding School", numberOfStudents: 565, grades: "PK-5" },
      { schoolName: "Bluff School", numberOfStudents: 79, grades: "PK-5" },
      { schoolName: "La Sal School", numberOfStudents: 9, grades: "PK-3" },
      {
        schoolName: "Montezuma Creek School",
        numberOfStudents: 285,
        grades: "PK-6",
      },
      { schoolName: "Monticello High", numberOfStudents: 234, grades: "7-12" },
      {
        schoolName: "Monticello School",
        numberOfStudents: 302,
        grades: "PK-6",
      },
      {
        schoolName: "Monument Valley High",
        numberOfStudents: 216,
        grades: "7-12",
      },
      {
        schoolName: "Navajo Mountain High",
        numberOfStudents: 26,
        grades: "9-12",
      },
      { schoolName: "San Juan High", numberOfStudents: 428, grades: "6-12" },
      {
        schoolName: "Tse'Bii'Nidzisgai School",
        numberOfStudents: 255,
        grades: "PK-6",
      },
      { schoolName: "Whitehorse High", numberOfStudents: 299, grades: "7-12" },
    ],
  },
  sevier: {
    districtName: "Sevier",
    schools: [
      { schoolName: "Ashman School", numberOfStudents: 508, grades: "KG-2" },
      { schoolName: "Cedar Ridge High", numberOfStudents: 71, grades: "6-12" },
      { schoolName: "Koosharem School", numberOfStudents: 38, grades: "KG-6" },
      { schoolName: "Monroe School", numberOfStudents: 587, grades: "KG-5" },
      {
        schoolName: "North Sevier High",
        numberOfStudents: 280,
        grades: "9-12",
      },
      {
        schoolName: "North Sevier Middle",
        numberOfStudents: 228,
        grades: "6-8",
      },
      { schoolName: "Pahvant School", numberOfStudents: 469, grades: "3-5" },
      { schoolName: "Red Hills Middle", numberOfStudents: 561, grades: "6-8" },
      { schoolName: "Richfield High", numberOfStudents: 739, grades: "9-12" },
      {
        schoolName: "Richfield Preschool",
        numberOfStudents: 179,
        grades: "PK-PK",
      },
      { schoolName: "Salina School", numberOfStudents: 420, grades: "KG-5" },
      {
        schoolName: "Sevier Career And Technical Education Center",
        numberOfStudents: 0,
        grades: "9-12",
      },
      {
        schoolName: "South Sevier High",
        numberOfStudents: 411,
        grades: "9-12",
      },
      {
        schoolName: "South Sevier Middle",
        numberOfStudents: 316,
        grades: "6-8",
      },
    ],
  },
  southSanpete: {
    districtName: "South Sanpete",
    schools: [
      { schoolName: "Ephraim Middle", numberOfStudents: 494, grades: "6-8" },
      { schoolName: "Ephraim School", numberOfStudents: 527, grades: "PK-5" },
      {
        schoolName: "Gunnison Valley High",
        numberOfStudents: 352,
        grades: "9-12",
      },
      {
        schoolName: "Gunnison Valley Middle",
        numberOfStudents: 252,
        grades: "6-8",
      },
      {
        schoolName: "Gunnison Valley School",
        numberOfStudents: 544,
        grades: "PK-5",
      },
      { schoolName: "Manti High", numberOfStudents: 693, grades: "9-12" },
      { schoolName: "Manti School", numberOfStudents: 436, grades: "PK-5" },
      {
        schoolName: "South Sanpete Education Support Center",
        numberOfStudents: 12,
        grades: "KG-12",
      },
    ],
  },
  southSummit: {
    districtName: "South Summit",
    schools: [
      {
        schoolName: "Silver Summit Academy",
        numberOfStudents: 97,
        grades: "6-12",
      },
      {
        schoolName: "Silver Summit School",
        numberOfStudents: 82,
        grades: "KG-5",
      },
      {
        schoolName: "South Summit High",
        numberOfStudents: 518,
        grades: "9-12",
      },
      {
        schoolName: "South Summit Middle",
        numberOfStudents: 480,
        grades: "5-8",
      },
      {
        schoolName: "South Summit Preschool",
        numberOfStudents: 0,
        grades: "PK-PK",
      },
      {
        schoolName: "South Summit School",
        numberOfStudents: 540,
        grades: "PK-4",
      },
    ],
  },
  tintic: {
    districtName: "Tintic",
    schools: [
      { schoolName: "Eureka School", numberOfStudents: 107, grades: "PK-6" },
      { schoolName: "Tintic High", numberOfStudents: 136, grades: "7-12" },
      { schoolName: "Tintic Preschool", numberOfStudents: 0, grades: "PK-PK" },
      {
        schoolName: "West Desert High School",
        numberOfStudents: 10,
        grades: "7-12",
      },
      {
        schoolName: "West Desert School",
        numberOfStudents: 14,
        grades: "PK-6",
      },
    ],
  },
  tooele: {
    districtName: "Tooele County",
    schools: [
      {
        schoolName: "Anna Smith School",
        numberOfStudents: 206,
        grades: "PK-6",
      },
      { schoolName: "Blue Peak High", numberOfStudents: 103, grades: "KG-12" },
      {
        schoolName: "Clarke N. Johnsen Jr High",
        numberOfStudents: 892,
        grades: "7-8",
      },
      {
        schoolName: "Copper Canyon School",
        numberOfStudents: 468,
        grades: "PK-6",
      },
      {
        schoolName: "Digital Education Center",
        numberOfStudents: 8561,
        grades: "KG-12",
      },
      { schoolName: "Dugway", numberOfStudents: 125, grades: "KG-12" },
      {
        schoolName: "Grantsville High",
        numberOfStudents: 1011,
        grades: "9-12",
      },
      {
        schoolName: "Grantsville Jr High",
        numberOfStudents: 515,
        grades: "7-8",
      },
      {
        schoolName: "Grantsville School",
        numberOfStudents: 725,
        grades: "PK-6",
      },
      { schoolName: "Ibapah School", numberOfStudents: 20, grades: "KG-6" },
      {
        schoolName: "Middle Canyon School",
        numberOfStudents: 617,
        grades: "KG-6",
      },
      { schoolName: "Northlake School", numberOfStudents: 619, grades: "PK-6" },
      { schoolName: "Old Mill School", numberOfStudents: 650, grades: "PK-6" },
      { schoolName: "Overlake School", numberOfStudents: 596, grades: "KG-6" },
      {
        schoolName: "Rose Springs School",
        numberOfStudents: 527,
        grades: "PK-6",
      },
      {
        schoolName: "Settlement Canyon School",
        numberOfStudents: 604,
        grades: "KG-6",
      },
      { schoolName: "Stansbury High", numberOfStudents: 2010, grades: "9-12" },
      {
        schoolName: "Stansbury Park School",
        numberOfStudents: 689,
        grades: "PK-6",
      },
      { schoolName: "Sterling School", numberOfStudents: 829, grades: "PK-6" },
      {
        schoolName: "Tooele Community Learning Center",
        numberOfStudents: 302,
        grades: "9-12",
      },
      { schoolName: "Tooele High", numberOfStudents: 1768, grades: "9-12" },
      { schoolName: "Tooele Jr High", numberOfStudents: 733, grades: "7-8" },
      {
        schoolName: "Twenty Wells Elementary",
        numberOfStudents: 576,
        grades: "PK-6",
      },
      { schoolName: "Vernon School", numberOfStudents: 34, grades: "KG-6" },
      { schoolName: "Wendover High", numberOfStudents: 189, grades: "7-12" },
      { schoolName: "West School", numberOfStudents: 256, grades: "PK-6" },
      { schoolName: "Willow School", numberOfStudents: 430, grades: "KG-6" },
    ],
  },
  uintah: {
    districtName: "Uintah",
    schools: [
      { schoolName: "Ashley School", numberOfStudents: 517, grades: "KG-5" },
      {
        schoolName: "Ashley Valley Educ. Ctr.",
        numberOfStudents: 287,
        grades: "8-12",
      },
      { schoolName: "Davis School", numberOfStudents: 441, grades: "KG-5" },
      { schoolName: "Discovery School", numberOfStudents: 700, grades: "KG-5" },
      {
        schoolName: "Eagle View School",
        numberOfStudents: 288,
        grades: "KG-8",
      },
      { schoolName: "Lapoint School", numberOfStudents: 151, grades: "KG-5" },
      { schoolName: "Maeser School", numberOfStudents: 550, grades: "KG-5" },
      { schoolName: "Naples School", numberOfStudents: 502, grades: "KG-5" },
      { schoolName: "Uintah High", numberOfStudents: 1808, grades: "9-12" },
      {
        schoolName: "Uintah Middle School",
        numberOfStudents: 669,
        grades: "6-8",
      },
      {
        schoolName: "Uintah Online School",
        numberOfStudents: 57,
        grades: "KG-8",
      },
      {
        schoolName: "Uintah Specialized Preschool",
        numberOfStudents: 185,
        grades: "PK-PK",
      },
      { schoolName: "Vernal Middle", numberOfStudents: 849, grades: "6-8" },
    ],
  },
  wasatch: {
    districtName: "Wasatch",
    schools: [
      {
        schoolName: "Daniels Canyon School",
        numberOfStudents: 608,
        grades: "PK-5",
      },
      {
        schoolName: "Heber Valley School",
        numberOfStudents: 598,
        grades: "PK-5",
      },
      {
        schoolName: "J.R. Smith School",
        numberOfStudents: 665,
        grades: "PK-5",
      },
      { schoolName: "Midway School", numberOfStudents: 675, grades: "PK-5" },
      { schoolName: "Old Mill School", numberOfStudents: 821, grades: "PK-5" },
      {
        schoolName: "Rocky Mountain Middle",
        numberOfStudents: 717,
        grades: "6-8",
      },
      {
        schoolName: "Timpanogos Middle School",
        numberOfStudents: 1007,
        grades: "6-8",
      },
      { schoolName: "Wasatch High", numberOfStudents: 2531, grades: "9-12" },
      {
        schoolName: "Wasatch Learning Academy",
        numberOfStudents: 1460,
        grades: "KG-8",
      },
    ],
  },
  washington: {
    districtName: "Washington County",
    schools: [
      { schoolName: "Arrowhead School", numberOfStudents: 552, grades: "PK-5" },
      {
        schoolName: "Bloomington Hills School",
        numberOfStudents: 494,
        grades: "PK-5",
      },
      {
        schoolName: "Bloomington School",
        numberOfStudents: 576,
        grades: "PK-5",
      },
      {
        schoolName: "Coral Canyon School",
        numberOfStudents: 565,
        grades: "PK-5",
      },
      {
        schoolName: "Coral Cliffs School",
        numberOfStudents: 135,
        grades: "PK-5",
      },
      {
        schoolName: "Crimson Cliffs High",
        numberOfStudents: 1334,
        grades: "10-12",
      },
      {
        schoolName: "Crimson Cliffs Middle",
        numberOfStudents: 978,
        grades: "8-9",
      },
      {
        schoolName: "Crimson View School",
        numberOfStudents: 577,
        grades: "PK-5",
      },
      {
        schoolName: "Desert Canyons Elementary",
        numberOfStudents: 510,
        grades: "KG-5",
      },
      {
        schoolName: "Desert Hills High",
        numberOfStudents: 1210,
        grades: "10-12",
      },
      {
        schoolName: "Desert Hills Middle",
        numberOfStudents: 895,
        grades: "8-9",
      },
      {
        schoolName: "Diamond Valley School",
        numberOfStudents: 353,
        grades: "PK-5",
      },
      { schoolName: "Dixie High", numberOfStudents: 1293, grades: "10-12" },
      { schoolName: "Dixie Middle", numberOfStudents: 854, grades: "8-9" },
      { schoolName: "Enterprise High", numberOfStudents: 546, grades: "7-12" },
      {
        schoolName: "Enterprise School",
        numberOfStudents: 497,
        grades: "PK-6",
      },
      {
        schoolName: "Fossil Ridge Intermediate",
        numberOfStudents: 734,
        grades: "6-7",
      },
      { schoolName: "Heritage School", numberOfStudents: 520, grades: "PK-5" },
      { schoolName: "Horizon School", numberOfStudents: 540, grades: "PK-5" },
      { schoolName: "Hurricane High", numberOfStudents: 1201, grades: "PK-12" },
      {
        schoolName: "Hurricane Intermediate",
        numberOfStudents: 784,
        grades: "PK-7",
      },
      { schoolName: "Hurricane Middle", numberOfStudents: 864, grades: "PK-9" },
      { schoolName: "Hurricane School", numberOfStudents: 706, grades: "PK-5" },
      {
        schoolName: "Lava Ridge Intermediate",
        numberOfStudents: 815,
        grades: "6-7",
      },
      { schoolName: "Laverkin School", numberOfStudents: 411, grades: "PK-5" },
      { schoolName: "Legacy School", numberOfStudents: 565, grades: "PK-5" },
      {
        schoolName: "Little Valley School",
        numberOfStudents: 670,
        grades: "PK-5",
      },
      {
        schoolName: "Majestic Fields School",
        numberOfStudents: 716,
        grades: "PK-5",
      },
      { schoolName: "Millcreek High", numberOfStudents: 160, grades: "7-12" },
      {
        schoolName: "Out Of State School",
        numberOfStudents: 0,
        grades: "PK-12",
      },
      { schoolName: "Panorama School", numberOfStudents: 496, grades: "PK-5" },
      { schoolName: "Paradise Canyon", numberOfStudents: 478, grades: "PK-5" },
      { schoolName: "Pine View High", numberOfStudents: 1143, grades: "10-12" },
      { schoolName: "Pine View Middle", numberOfStudents: 779, grades: "8-9" },
      {
        schoolName: "Post Hs Self-Cont",
        numberOfStudents: 78,
        grades: "KG-12",
      },
      {
        schoolName: "Red Mountain School",
        numberOfStudents: 434,
        grades: "PK-5",
      },
      { schoolName: "Riverside School", numberOfStudents: 610, grades: "PK-5" },
      { schoolName: "Sandstone School", numberOfStudents: 506, grades: "PK-5" },
      {
        schoolName: "Santa Clara School",
        numberOfStudents: 483,
        grades: "PK-5",
      },
      {
        schoolName: "Snow Canyon High",
        numberOfStudents: 1266,
        grades: "10-12",
      },
      {
        schoolName: "Snow Canyon Middle",
        numberOfStudents: 909,
        grades: "PK-9",
      },
      {
        schoolName: "South Mesa Elementary",
        numberOfStudents: 565,
        grades: "KG-5",
      },
      { schoolName: "Southwest High", numberOfStudents: 0, grades: "9-12" },
      { schoolName: "Springdale School", numberOfStudents: 51, grades: "PK-5" },
      {
        schoolName: "Sunrise Ridge Intermediate",
        numberOfStudents: 810,
        grades: "6-7",
      },
      { schoolName: "Sunset School", numberOfStudents: 496, grades: "PK-5" },
      {
        schoolName: "Three Falls School",
        numberOfStudents: 592,
        grades: "PK-5",
      },
      {
        schoolName: "Tonaquint Intermediate",
        numberOfStudents: 735,
        grades: "6-7",
      },
      {
        schoolName: "Utah Online 7-12",
        numberOfStudents: 1220,
        grades: "6-12",
      },
      { schoolName: "Utah Online K8", numberOfStudents: 3428, grades: "KG-8" },
      {
        schoolName: "Washington Fields Intermediate",
        numberOfStudents: 830,
        grades: "6-7",
      },
      {
        schoolName: "Washington Preschool",
        numberOfStudents: 507,
        grades: "PK-PK",
      },
      {
        schoolName: "Washington School",
        numberOfStudents: 463,
        grades: "PK-5",
      },
      {
        schoolName: "Water Canyon High",
        numberOfStudents: 349,
        grades: "7-12",
      },
      {
        schoolName: "Water Canyon School",
        numberOfStudents: 289,
        grades: "PK-6",
      },
    ],
  },
  wayne: {
    districtName: "Wayne County",
    schools: [
      { schoolName: "Hanksville School", numberOfStudents: 16, grades: "PK-6" },
      { schoolName: "Loa School", numberOfStudents: 230, grades: "PK-5" },
      { schoolName: "Wayne High", numberOfStudents: 139, grades: "9-12" },
      { schoolName: "Wayne Middle", numberOfStudents: 88, grades: "6-8" },
    ],
  },
  weber: {
    districtName: "Weber",
    schools: [
      { schoolName: "Bates School", numberOfStudents: 728, grades: "KG-6" },
      {
        schoolName: "Bonneville High",
        numberOfStudents: 1361,
        grades: "10-12",
      },
      {
        schoolName: "Burch Creek School",
        numberOfStudents: 559,
        grades: "KG-6",
      },
      {
        schoolName: "Canyon View Preschool",
        numberOfStudents: 98,
        grades: "PK-PK",
      },
      {
        schoolName: "Country View School",
        numberOfStudents: 572,
        grades: "KG-6",
      },
      { schoolName: "Farr West School", numberOfStudents: 788, grades: "KG-6" },
      { schoolName: "Freedom School", numberOfStudents: 819, grades: "KG-6" },
      { schoolName: "Fremont High", numberOfStudents: 2160, grades: "10-12" },
      {
        schoolName: "Green Acres School",
        numberOfStudents: 546,
        grades: "KG-6",
      },
      {
        schoolName: "H Guy Child School",
        numberOfStudents: 410,
        grades: "KG-6",
      },
      { schoolName: "Hooper School", numberOfStudents: 656, grades: "KG-6" },
      { schoolName: "Horizon Academy", numberOfStudents: 80, grades: "6-12" },
      {
        schoolName: "Kanesville School",
        numberOfStudents: 988,
        grades: "KG-6",
      },
      { schoolName: "Lakeview School", numberOfStudents: 441, grades: "KG-6" },
      {
        schoolName: "Lomond View School",
        numberOfStudents: 483,
        grades: "KG-6",
      },
      { schoolName: "Majestic School", numberOfStudents: 771, grades: "KG-6" },
      { schoolName: "Midland School", numberOfStudents: 568, grades: "PK-6" },
      { schoolName: "Municipal School", numberOfStudents: 331, grades: "KG-6" },
      { schoolName: "New High Weber", numberOfStudents: 0, grades: "" },
      {
        schoolName: "North Ogden Jr High",
        numberOfStudents: 936,
        grades: "7-9",
      },
      {
        schoolName: "North Ogden School",
        numberOfStudents: 560,
        grades: "KG-6",
      },
      {
        schoolName: "North Park School",
        numberOfStudents: 467,
        grades: "KG-6",
      },
      { schoolName: "Orchard Springs", numberOfStudents: 480, grades: "KG-6" },
      { schoolName: "Orion Jr High", numberOfStudents: 1063, grades: "7-9" },
      { schoolName: "Pioneer School", numberOfStudents: 414, grades: "KG-6" },
      {
        schoolName: "Plain City School",
        numberOfStudents: 638,
        grades: "KG-6",
      },
      { schoolName: "Riverdale School", numberOfStudents: 416, grades: "KG-6" },
      {
        schoolName: "Rocky Mountain Jr High",
        numberOfStudents: 1225,
        grades: "7-9",
      },
      { schoolName: "Roosevelt School", numberOfStudents: 502, grades: "KG-6" },
      { schoolName: "Roy High", numberOfStudents: 1834, grades: "10-12" },
      { schoolName: "Roy Jr High", numberOfStudents: 1008, grades: "7-9" },
      { schoolName: "Roy School", numberOfStudents: 503, grades: "KG-6" },
      {
        schoolName: "Sand Ridge Jr High",
        numberOfStudents: 857,
        grades: "7-9",
      },
      {
        schoolName: "Silver Ridge Elementary",
        numberOfStudents: 625,
        grades: "KG-6",
      },
      { schoolName: "Snowcrest Jr High", numberOfStudents: 280, grades: "7-9" },
      {
        schoolName: "South Ogden Jr High",
        numberOfStudents: 846,
        grades: "7-9",
      },
      { schoolName: "T.H. Bell Jr High", numberOfStudents: 670, grades: "7-9" },
      { schoolName: "Two Rivers High", numberOfStudents: 218, grades: "7-12" },
      { schoolName: "Uintah School", numberOfStudents: 681, grades: "KG-6" },
      { schoolName: "Valley School", numberOfStudents: 617, grades: "KG-6" },
      {
        schoolName: "Valley View School",
        numberOfStudents: 336,
        grades: "KG-6",
      },
      {
        schoolName: "Wahlquist Jr High",
        numberOfStudents: 1260,
        grades: "7-9",
      },
      {
        schoolName: "Washington Terrace School",
        numberOfStudents: 493,
        grades: "KG-6",
      },
      { schoolName: "Weber High", numberOfStudents: 2037, grades: "10-12" },
      {
        schoolName: "Weber Hq Preschool",
        numberOfStudents: 0,
        grades: "PK-PK",
      },
      {
        schoolName: "Weber Innovation High School",
        numberOfStudents: 390,
        grades: "6-12",
      },
      { schoolName: "Weber New Elementary", numberOfStudents: 0, grades: "" },
      {
        schoolName: "Weber New Middle School",
        numberOfStudents: 0,
        grades: "",
      },
      { schoolName: "Weber Online 7-8", numberOfStudents: 0, grades: "7-8" },
      { schoolName: "Weber Online 9-12", numberOfStudents: 0, grades: "9-12" },
      { schoolName: "Weber Online K-6", numberOfStudents: 65, grades: "KG-6" },
      {
        schoolName: "West Haven School",
        numberOfStudents: 540,
        grades: "KG-6",
      },
      {
        schoolName: "West Weber School",
        numberOfStudents: 568,
        grades: "KG-6",
      },
    ],
  },
};

export const districtList = [
  {
    district: "Alpine School District",
    districtSlug: "alpine",
    schools: 92,
    county: "Utah",
    ncesId: 4900030,
    stateId: "UT-01",
    website: "https://alpineschools.org/",
    logo: alpine,
  },
  {
    district: "Beaver School District",
    districtSlug: "beaver",
    schools: 7,
    county: "Beaver",
    ncesId: 4900060,
    stateId: "UT-02",
    website: "https://www.beaver.k12.ut.us",
    logo: beaver,
  },
  {
    district: "Box Elder School District",
    districtSlug: "boxelder",
    schools: 23,
    county: "Box Elder",
    ncesId: 4900090,
    stateId: "UT-03",
    website: "https://www.besd.net/",
    logo: boxelder,
  },
  {
    district: "Cache County School District",
    districtSlug: "cache",
    schools: 26,
    county: "Cache",
    ncesId: 4900120,
    stateId: "UT-04",
    website: "https://www.ccsdut.org/",
    logo: cache,
  },
  {
    district: "Canyons School District",
    districtSlug: "canyons",
    schools: 50,
    county: "Utah",
    ncesId: 4900142,
    stateId: "UT-42",
    website: "https://www.canyonsdistrict.org/",
    logo: canyons,
  },
  {
    district: "Carbon School District",
    districtSlug: "carbon",
    schools: 9,
    county: "Carbon",
    ncesId: 4900150,
    stateId: "UT-05",
    website: "https://www.carbonschools.org/",
    logo: carbon,
  },
  {
    district: "Daggett School District",
    districtSlug: "daggett",
    schools: 4,
    county: "Daggett",
    ncesId: 4900180,
    stateId: "UT-06",
    website: "https://www.dsdf.org/",
    logo: daggett,
  },
  {
    district: "Davis School District",
    districtSlug: "davis",
    schools: 96,
    county: "Utah",
    ncesId: 4900210,
    stateId: "UT-07",
    website: "https://www.davis.k12.ut.us/",
    logo: davis,
  },
  {
    district: "Duchesne County School District",
    districtSlug: "duchesne",
    schools: 15,
    county: "Duchesne",
    ncesId: 4900240,
    stateId: "UT-08",
    website: "https://www.dcsd.org/en-US/schools",
    logo: duchesne,
  },
  {
    district: "Emery School District",
    districtSlug: "emery",
    schools: 10,
    county: "Emery",
    ncesId: 4900270,
    stateId: "UT-09",
    website: "https://www.emeryschools.org",
    logo: emery,
  },
  {
    district: "Garfield School District",
    districtSlug: "garfield",
    schools: 10,
    county: "Garfield",
    ncesId: 4900300,
    stateId: "UT-10",
    website: "http://www.garfk12.org/",
    logo: garfield,
  },
  {
    district: "Grand County School District",
    districtSlug: "grand",
    schools: 4,
    county: "Grand",
    ncesId: 4900330,
    stateId: "UT-11",
    website: "https://www.grandschools.org/",
    logo: grand,
  },
  {
    district: "Granite School District",
    districtSlug: "granite",
    schools: 89,
    county: "Utah",
    ncesId: 4900360,
    stateId: "UT-12",
    website: "https://www.graniteschools.org/",
    logo: granite,
  },
  {
    district: "Iron County School District",
    districtSlug: "iron",
    schools: 18,
    county: "Iron",
    ncesId: 4900390,
    stateId: "UT-13",
    website: "https://www.irondistrict.org/",
    logo: iron,
  },
  {
    district: "Jordan School District",
    districtSlug: "jordan",
    schools: 70,
    county: "Utah",
    ncesId: 4900420,
    stateId: "UT-14",
    website: "https://jordandistrict.org/",
    logo: jordan,
  },
  {
    district: "Juab School District",
    districtSlug: "juab",
    schools: 6,
    county: "Juab",
    ncesId: 4900450,
    stateId: "UT-15",
    website: "https://www.juabsd.org/",
    logo: juab,
  },
  {
    district: "Kane School District",
    districtSlug: "kane",
    schools: 10,
    county: "Kane",
    ncesId: 4900480,
    stateId: "UT-16",
    website: "http://www.kane.k12.ut.us/",
    logo: kane,
  },
  {
    district: "Logan School District",
    districtSlug: "logan",
    schools: 11,
    county: "Cache",
    ncesId: 4900510,
    stateId: "UT-39",
    website: "https://www.loganschools.org/",
    logo: logan,
  },
  {
    district: "Millard School District",
    districtSlug: "millard",
    schools: 9,
    county: "Millard",
    ncesId: 4900540,
    stateId: "UT-17",
    website: "https://www.millardk12.org",
    logo: millard,
  },
  {
    district: "Morgan School District",
    districtSlug: "morgan",
    schools: 8,
    county: "Morgan",
    ncesId: 4900570,
    stateId: "UT-18",
    website: "https://www.morgansd.org/",
    logo: morgan,
  },
  {
    district: "Murray School District",
    districtSlug: "murray",
    schools: 12,
    county: "Salt Lake",
    ncesId: 4900600,
    stateId: "UT-40",
    website: "https://www.murrayschools.org/",
    logo: murray,
  },
  {
    district: "Nebo School District",
    districtSlug: "nebo",
    schools: 49,
    county: "Utah",
    ncesId: 4900630,
    stateId: "UT-19",
    website: "https://www.nebo.edu/",
    logo: nebo,
  },
  {
    district: "North Sanpete School District",
    districtSlug: "sanpete",
    schools: 8,
    county: "Sanpete",
    ncesId: 4900660,
    stateId: "UT-20",
    website: "https://www.nsanpete.org/",
    logo: North,
  },
  {
    district: "North Summit School District",
    districtSlug: "summit",
    schools: 4,
    county: "Summit",
    ncesId: 4900690,
    stateId: "UT-21",
    website: "https://www.nsummit.org/",
    logo: northsummit,
  },
  {
    district: "Ogden School District",
    districtSlug: "ogden",
    schools: 24,
    county: "Weber",
    ncesId: 4900720,
    stateId: "UT-37",
    website: "https://www.ogdensd.org/",
    logo: ogden,
  },
  {
    district: "Park City School District",
    districtSlug: "park",
    schools: 12,
    county: "Summit",
    ncesId: 4900750,
    stateId: "UT-22",
    website: "https://www.pcschools.us/",
    logo: park,
  },
  {
    district: "Piute School District",
    districtSlug: "piute",
    schools: 5,
    county: "Piute",
    ncesId: 4900780,
    stateId: "UT-23",
    website: "http://www.piutek12.org/",
    logo: piute,
  },
  {
    district: "Provo City School District",
    districtSlug: "provo",
    schools: 23,
    county: "Utah",
    ncesId: 4900810,
    stateId: "UT-38",
    website: "http://www.provo.edu/",
    logo: provo,
  },
  {
    district: "Rich School District",
    districtSlug: "rich",
    schools: 5,
    county: "Rich",
    ncesId: 4900840,
    stateId: "UT-24",
    website: "https://www.richschool.org/",
    logo: rich,
  },
  {
    district: "Salt Lake City School District",
    districtSlug: "salt",
    schools: 41,
    county: "Salt Lake",
    ncesId: 4900870,
    stateId: "UT-36",
    website: "https://www.slcschools.org/",
    logo: saltLake,
  },
  {
    district: "San Juan School District",
    districtSlug: "san",
    schools: 12,
    county: "San Juan",
    ncesId: 4900900,
    stateId: "UT-25",
    website: "https://www.sjsd.org/",
    logo: san,
  },
  {
    district: "Sevier School District",
    districtSlug: "sevier",
    schools: 14,
    county: "Sevier",
    ncesId: 4900930,
    stateId: "UT-26",
    website: "https://www.seviersd.org/index.php",
    logo: sevier,
  },
  {
    district: "South Sanpete School District",
    districtSlug: "southSanpete",
    schools: 8,
    county: "Sanpete",
    ncesId: 4900960,
    stateId: "UT-27",
    website: "https://www.ssanpete.org",
    logo: southSanpete,
  },
  {
    district: "South Summit School District",
    districtSlug: "southSummit",
    schools: 6,
    county: "Summit",
    ncesId: 4900990,
    stateId: "UT-28",
    website: "https://www.ssummit.org/",
    logo: southSummit,
  },
  {
    district: "Tintic School District",
    districtSlug: "tintic",
    schools: 5,
    county: "Juab",
    ncesId: 4901020,
    stateId: "UT-29",
    website: "https://www.tintic.org/",
    logo: tintic,
  },
  {
    district: "Tooele County School District",
    districtSlug: "tooele",
    schools: 27,
    county: "Tooele",
    ncesId: 4901050,
    stateId: "UT-30",
    website: "https://www.tooeleschools.org/",
    logo: tooele,
  },
  {
    district: "Uintah School District",
    districtSlug: "uintah",
    schools: 13,
    county: "Uintah",
    ncesId: 4901080,
    stateId: "UT-31",
    website: "https://www.uintah.net/",
    logo: uintah,
  },
  {
    district: "Wasatch School District",
    districtSlug: "wasatch",
    schools: 9,
    county: "Wasatch",
    ncesId: 4901110,
    stateId: "UT-32",
    website: "https://wasatch.edu/",
    logo: wasatch,
  },
  {
    district: "Washington County School District",
    districtSlug: "washington",
    schools: 55,
    county: "Utah",
    ncesId: 4901140,
    stateId: "UT-33",
    website: "https://www.washk12.org/",
    logo: washington,
  },
  {
    district: "Wayne County School District",
    districtSlug: "wayne",
    schools: 4,
    county: "Wayne",
    ncesId: 4901170,
    stateId: "UT-34",
    website: "https://www.waynesd.org/",
    logo: wayne,
  },
  {
    district: "Weber School District",
    districtSlug: "weber",
    schools: 53,
    county: "Utah",
    ncesId: 4901200,
    stateId: "UT-35",
    website: "https://www.wsd.net",
    logo: weber,
  },
];

export const charterSchools = [
  { "County Name": "Beaver", "Number of Charter Schools": 0 },
  {
    "County Name": "Box Elder", "Number of Charter Schools": 1,
    "Charter Schools": [
      {
        "Charter School Name": "Promontory School of Expeditionary Learning",
        "Located at": "Perry, UT",
        "Website": "http://promontoryschool.org"
      }
    ]
  },
  {
    "County Name": "Cache", "Number of Charter Schools": 7,
    "Charter Schools": [
      {
        "Charter School Name": "American Leadership Academy",
        "Located at": "Spanish Fork, UT",
        "Website": "americanleadershipacademy.org"
      },
      {
        "Charter School Name": "American Preparatory Academy - Salem",
        "Located at": "Salem, UT",
        "Website": "salem.americanprep.org"
      },
      {
        "Charter School Name": "Aristotle Academy",
        "Located at": "American Fork, UT",
        "Website": "aristotleacademy.org"
      },
      {
        "Charter School Name": "Ascent Academies (Saratoga Springs)",
        "Located at": "Saratoga Springs, UT",
        "Website": "ascentutah.org/"
      },
      {
        "Charter School Name": "Ascent Academies of Utah Lehi",
        "Located at": "Lehi, UT",
        "Website": "farmington.ascentutah.org"
      },
      {
        "Charter School Name": "Athenian eAcademy",
        "Located at": "American Fork, UT",
        "Website": "aea.rocks"
      },
      {
        "Charter School Name": "Azure Fields Charter High School",
        "Located at": "Orem, UT",
        "Website": "azurefields.org"
      },
      {
        "Charter School Name": "Canyon Grove Academy",
        "Located at": "Pleasant Grove, UT",
        "Website": "http://www.canyongrove.com"
      },
      {
        "Charter School Name": "C.S. Lewis Academy",
        "Located at": "Santaquin, UT",
        "Website": "cslewisacademy.net"
      },
      {
        "Charter School Name": "Elevated Charter School",
        "Located at": "Lehi, UT",
        "Website": "elevatedcharterschool.org"
      },
      {
        "Charter School Name": "Franklin Discovery Academy",
        "Located at": "Vineyard, UT",
        "Website": "franklindiscovery.org"
      },
      {
        "Charter School Name": "Freedom Preparatory Academy - Provo Elementary and Secondary",
        "Located at": "Provo, UT",
        "Website": "freedomprep.net"
      },
      {
        "Charter School Name": "Freedom Preparatory Academy - Vineyard Elementary",
        "Located at": "Vineyard, UT",
        "Website": "freedomprep.net/vineyard-elementary"
      },
      {
        "Charter School Name": "Ignite Entrepreneurship Academy",
        "Located at": "Lehi, UT",
        "Website": "https://igniteutah.org/"
      },
      {
        "Charter School Name": "John Hancock Charter School",
        "Located at": "Pleasant Grove, UT",
        "Website": "johnhancockcs.org"
      },
      {
        "Charter School Name": "Karl G. Maeser Preparatory Academy",
        "Located at": "Lindon, UT",
        "Website": "maeserprep.org"
      },
      {
        "Charter School Name": "Lakeview Academy",
        "Located at": "Saratoga Springs, UT",
        "Website": "lakeview-academy.com/saratoga-springs/saratoga-springs-home"
      },
      {
        "Charter School Name": "Lincoln Academy",
        "Located at": "Pleasant Grove, UT",
        "Website": "lincoln-academy.org"
      },
      {
        "Charter School Name": "Merit College Preparatory Academy",
        "Located at": "Springville, UT",
        "Website": "meritprepacademy.org"
      },
      {
        "Charter School Name": "Mountainville Academy",
        "Located at": "Alpine, UT",
        "Website": "http://www.mountainvilleacademy.org"
      },
      {
        "Charter School Name": "Mountain Sunrise Academy",
        "Located at": "Saratoga Springs, UT",
        "Website": "mountainsunriseacademy.org"
      },
      {
        "Charter School Name": "Noah Webster Academy",
        "Located at": "Orem, UT",
        "Website": "noahwebsteracademy.org"
      },
      {
        "Charter School Name": "Odyssey Charter School",
        "Located at": "American Fork, UT",
        "Website": "odysseycharter.net"
      },
      {
        "Charter School Name": "Reagan Academy",
        "Located at": "Springville, UT",
        "Website": "reaganacademy.org"
      },
      {
        "Charter School Name": "Renaissance Academy",
        "Located at": "Lehi, UT",
        "Website": "renacademy.org"
      },
      {
        "Charter School Name": "Rockwell Charter High School",
        "Located at": "Eagle Mountain, UT",
        "Website": "rockwellhigh.net"
      },
      {
        "Charter School Name": "Spectrum Academy - Pleasant Grove",
        "Located at": "Pleasant Grove, UT",
        "Website": "spectrumcharter.org"
      },
      {
        "Charter School Name": "The Ranches Academy",
        "Located at": "Eagle Mountain, UT",
        "Website": "theranchesacademy.org"
      },
      {
        "Charter School Name": "Timpanogos Academy",
        "Located at": "Lindon, UT",
        "Website": "timpacademy.org"
      },
      {
        "Charter School Name": "Treeside Charter School",
        "Located at": "Provo, UT",
        "Website": "treesidecharterschool.org"
      },
      {
        "Charter School Name": "Utah County Academy of Sciences (UCAS)",
        "Located at": "Orem, UT",
        "Website": "ucas-edu.net"
      },
      {
        "Charter School Name": "Utah Military Academy - Camp Williams",
        "Located at": "Lehi, UT",
        "Website": "www.umavp.org"
      },
      {
        "Charter School Name": "Walden School of Liberal Arts",
        "Located at": "Provo, UT",
        "Website": "waldenschool.us"
      }
    ]
  },
  {
    "County Name": "Carbon", "Number of Charter Schools": 1,
    "Charter Schools": [
      {
        "Charter School Name": "Pinnacle Canyon Academy",
        "Located at": "Price, UT",
        "Website": "pcaschool.com"
      }
    ]
  },
  { "County Name": "Daggett", "Number of Charter Schools": 0 },
  {
    "County Name": "Davis", "Number of Charter Schools": 15,
    "Charter Schools": [
      {
        "Charter School Name": "AMES (Academy for Math Engineering & Science)",
        "Located at": "Layton, UT",
        "Website": "nuames.org/dc/dc-home?dh=1"
      },
      {
        "Charter School Name": "Ascent Academies of Utah (Farmington)",
        "Located at": "Farmington, UT",
        "Website": "farmington.ascentutah.org"
      },
      {
        "Charter School Name": "Highmark Charter School",
        "Located at": "South Weber, UT",
        "Website": "highmarkhawks.com"
      },
      {
        "Charter School Name": "Jefferson Academy",
        "Located at": "Kaysville, UT",
        "Website": "jeffersonacademy.org"
      },
      {
        "Charter School Name": "Leadership Academy of Utah",
        "Located at": "Clearfield, UT",
        "Website": "www.lautah.org"
      },
      {
        "Charter School Name": "Leadership Learning Academy (Layton)",
        "Located at": "Layton, UT",
        "Website": "llacharter.org/lc/lc-home?dh=1"
      },
      {
        "Charter School Name": "Legacy Preparatory Academy",
        "Located at": "Woods Cross, UT",
        "Website": "legacyprep.org"
      },
      {
        "Charter School Name": "Monticello Academy West Point",
        "Located at": "West Point, UT",
        "Website": "monticelloacademy.net"
      },
      {
        "Charter School Name": "North Davis Preparatory Academy",
        "Located at": "Layton, UT",
        "Website": "academica.org"
      },
      {
        "Charter School Name": "Spectrum Academy (NSL Campus)",
        "Located at": "North Salt Lake, UT",
        "Website": "spectrumcharter.org"
      },
      {
        "Charter School Name": "Syracuse Arts Academy",
        "Located at": "Syracuse, UT",
        "Website": "syracuseartsacademy.org/antelope-eleme"
      },
      {
        "Charter School Name": "Utah Career Path High School",
        "Located at": "Kaysville, UT",
        "Website": "careerpathhigh.org"
      },
      {
        "Charter School Name": "Voyage Academy",
        "Located at": "Clinton, UT",
        "Website": "voyageacademyutah.org"
      },
      {
        "Charter School Name": "Wallace Stegner Academy Sunset",
        "Located at": "Sunset, UT",
        "Website": "wsacharter.org"
      },
      {
        "Charter School Name": "Wasatch Peak Academy",
        "Located at": "North Salt Lake, UT",
        "Website": "wasatchpeak.org"
      }
    ]
  },
  { "County Name": "Duchesne", "Number of Charter Schools": 0 },
  { "County Name": "Emery", "Number of Charter Schools": 0 },
  { "County Name": "Garfield", "Number of Charter Schools": 0 },
  { "County Name": "Grand", "Number of Charter Schools": 0 },
  {
    "County Name": "Iron", "Number of Charter Schools": 3,
    "Charter Schools": [
      {
        "Charter School Name": "American Principles Academy",
        "Located at": "Cedar City, UT",
        "Website": "https://www.americanprep.org/"
      },
      {
        "Charter School Name": "Gateway Preparatory Academy",
        "Located at": "Enoch, UT",
        "Website": "gpacharter.org"
      },
      {
        "Charter School Name": "SUU SUCCESS Academy",
        "Located at": "Cedar City, UT",
        "Website": "suusuccess.org"
      }
    ]
  },
  { "County Name": "Juab", "Number of Charter Schools": 0 },
  { "County Name": "Kane", "Number of Charter Schools": 0 },
  { "County Name": "Millard", "Number of Charter Schools": 0 },
  { "County Name": "Morgan", "Number of Charter Schools": 0 },
  { "County Name": "Piute", "Number of Charter Schools": 0 },
  { "County Name": "Rich", "Number of Charter Schools": 0 },
  {
    "County Name": "Salt Lake", "Number of Charter Schools": 56,
    "Charter Schools": [{
      "Charter School Name": "Academy for Math Engineering & Science (AMES)",
      "Located at": "Salt Lake City, UT",
      "Website": "ames-slc.org"
    },
    {
      "Charter School Name": "Advantage Arts Academy",
      "Located at": "Herriman, UT",
      "Website": "advantagearts.org"
    },
    {
      "Charter School Name": "American Academy of Innovation",
      "Located at": "South Jordan, UT",
      "Website": "aaiutah.org"
    },
    {
      "Charter School Name": "American Preparatory Academy (Draper #1)",
      "Located at": "Draper, UT",
      "Website": "draper1.americanprep.org"
    },
    {
      "Charter School Name": "American Preparatory Academy (Draper #2)",
      "Located at": "Draper, UT",
      "Website": "draper2.americanprep.org"
    },
    {
      "Charter School Name": "American Preparatory Academy (Draper #3)",
      "Located at": "Draper, UT",
      "Website": "draper3.americanprep.org"
    },
    {
      "Charter School Name": "American Preparatory Academy - The School for New Americans",
      "Located at": "West Valley City, UT",
      "Website": "americanprep.org/home"
    },
    {
      "Charter School Name": "American Preparatory Academy West Valley Campus I",
      "Located at": "West Valley City, UT",
      "Website": "westvalley1.americanprep.org"
    },
    {
      "Charter School Name": "American Preparatory Academy West Valley Campus II",
      "Located at": "West Valley City, UT",
      "Website": "westvalley2.americanprep.org"
    },
    {
      "Charter School Name": "Ascent Academies of Utah",
      "Located at": "West Jordan, UT",
      "Website": "westjordan.ascentutah.org"
    },
    {
      "Charter School Name": "Ascent Academies Of Utah - West Valley",
      "Located at": "West Valley City, UT",
      "Website": "farmington.ascentutah.org"
    },
    {
      "Charter School Name": "Beehive Science & Technology Academy",
      "Located at": "Sandy, UT",
      "Website": "beehiveacademy.org"
    },
    {
      "Charter School Name": "Canyon Rim Academy",
      "Located at": "Salt Lake City, UT",
      "Website": "canyonrimacademy.org"
    },
    {
      "Charter School Name": "Channing Hall",
      "Located at": "Draper, UT",
      "Website": "channinghall.org"
    },
    {
      "Charter School Name": "City Academy",
      "Located at": "Salt Lake City, UT",
      "Website": "cityacademyslc.org"
    },
    {
      "Charter School Name": "Dual Immersion Academy (DIA)",
      "Located at": "Salt Lake City, UT",
      "Website": "diacharter.org"
    },
    {
      "Charter School Name": "Early Light Academy at Daybreak",
      "Located at": "South Jordan, UT",
      "Website": "earlylightacademy.org"
    },
    {
      "Charter School Name": "East Hollywood High School",
      "Located at": "West Valley City, UT",
      "Website": "easthollywood.org"
    },
    {
      "Charter School Name": "Endeavor Hall",
      "Located at": "West Valley City, UT",
      "Website": "endeavorhall.org"
    },
    {
      "Charter School Name": "Entheos Academy",
      "Located at": "Kearns, UT",
      "Website": "entheosacademy.org"
    },
    {
      "Charter School Name": "Entheos Academy Magna",
      "Located at": "Magna, UT",
      "Website": "entheosacademy.org"
    },
    {
      "Charter School Name": "Esperanza School",
      "Located at": "West Valley City, UT",
      "Website": "esperanzaelementary.org/index.html"
    },
    {
      "Charter School Name": "Guadalupe School",
      "Located at": "Salt Lake City, UT",
      "Website": "guadschool.org"
    },
    {
      "Charter School Name": "Hawthorn Academy South Jordan",
      "Located at": "South Jordan, UT",
      "Website": "hawthornacademy.org"
    },
    {
      "Charter School Name": "Hawthorn Academy West Jordan",
      "Located at": "West Jordan, UT",
      "Website": "hawthornacademy.org"
    },
    {
      "Charter School Name": "Itineris Early College High School",
      "Located at": "West Jordan, UT",
      "Website": "iechs.org"
    },
    {
      "Charter School Name": "Mana Academy",
      "Located at": "West Valley City, UT",
      "Website": "themanaacademy.org"
    },
    {
      "Charter School Name": "Monticello Academy",
      "Located at": "West Valley City, UT",
      "Website": "monticelloacademy.net"
    },
    {
      "Charter School Name": "Mountain Heights Academy",
      "Located at": "West Jordan, UT",
      "Website": "mountainheightsacademy.org"
    },
    {
      "Charter School Name": "Mountain West Montessori Academy",
      "Located at": "South Jordan, UT",
      "Website": "mwmacademy.org"
    },
    {
      "Charter School Name": "Navigator Pointe Academy",
      "Located at": "West Jordan, UT",
      "Website": "navigatorpointeacademy.org"
    },
    {
      "Charter School Name": "North Star Academy",
      "Located at": "Bluffdale, UT",
      "Website": "north-staracademy.com"
    },
    {
      "Charter School Name": "Pacific Heritage Academy",
      "Located at": "Salt Lake City, UT",
      "Website": "phlearning.org"
    },
    {
      "Charter School Name": "Paradigm High School",
      "Located at": "South Jordan, UT",
      "Website": "paradigmschools.org"
    },
    {
      "Charter School Name": "Providence Hall (Elementary)",
      "Located at": "Herriman, UT",
      "Website": "providencehall.com"
    },
    {
      "Charter School Name": "Providence Hall (High School)",
      "Located at": "Herriman, UT",
      "Website": "providencehall.com/o/phhs"
    },
    {
      "Charter School Name": "Providence Hall (Junior High)",
      "Located at": "Herriman, UT",
      "Website": "providencehall.com/o/phjh"
    },
    {
      "Charter School Name": "Roots Charter High School",
      "Located at": "West Valley City, UT",
      "Website": "rootshigh.org"
    },
    {
      "Charter School Name": "Salt Lake Academy",
      "Located at": "Herriman, UT",
      "Website": "rslacademy.org"
    },
    {
      "Charter School Name": "Salt Lake Arts Academy",
      "Located at": "Salt Lake City, UT",
      "Website": "slarts.org"
    },
    {
      "Charter School Name": "Salt Lake Center for Science Education",
      "Located at": "Salt Lake City, UT",
      "Website": "slcse.slcschools.org"
    },
    {
      "Charter School Name": "Salt Lake City Open Classroom",
      "Located at": "Salt Lake City, UT",
      "Website": "ocslc.org"
    },
    {
      "Charter School Name": "Salt Lake School for the Performing Arts",
      "Located at": "Salt Lake City, UT",
      "Website": "saltlakespa.net"
    },
    {
      "Charter School Name": "Summit Academy",
      "Located at": "Bluffdale, UT",
      "Website": "summitacademyschools.org"
    },
    {
      "Charter School Name": "Summit Academy",
      "Located at": "Independence, UT",
      "Website": "independence.summitacademyschools.o"
    },
    {
      "Charter School Name": "Summit Academy - Draper Elementary",
      "Located at": "Draper, UT",
      "Website": "draper.summitacademyschools.org"
    },
    {
      "Charter School Name": "Summit Academy High School",
      "Located at": "Bluffdale, UT",
      "Website": "sahs.summitacademyschools.org"
    },
    {
      "Charter School Name": "ThrivePoint Academy of Utah",
      "Located at": "West Jordan, UT",
      "Website": "thrivepointutah.com"
    },
    {
      "Charter School Name": "Utah Connections Academy",
      "Located at": "Midvale, UT",
      "Website": "connectionsacademy.com/utah-school"
    },
    {
      "Charter School Name": "Utah International Charter School",
      "Located at": "South Salt Lake, UT",
      "Website": "utahinternational.org"
    },
    {
      "Charter School Name": "Utah Virtual Academy",
      "Located at": "Murray, UT",
      "Website": "utva.k12.com"
    },
    {
      "Charter School Name": "Vanguard Academy",
      "Located at": "West Valley City, UT",
      "Website": "vanguardcharter.org"
    },
    {
      "Charter School Name": "Wallace Stegner Academy",
      "Located at": "Salt Lake City, UT",
      "Website": "wsacharter.org"
    },
    {
      "Charter School Name": "Wallace Stegner Academy West Valley",
      "Located at": "West Valley City, UT",
      "Website": "wsacharter.org"
    },
    {
      "Charter School Name": "Wallace Stegner Academy Kearns K-12",
      "Located at": "West Valley City, UT",
      "Website": "wsacharter.org"
    },
    {
      "Charter School Name": "Wasatch Waldorf Charter School",
      "Located at": "Holladay, UT",
      "Website": "wasatchwaldorf.org"
    }
    ]
  },
  { "County Name": "San Juan", "Number of Charter Schools": 0 },
  { "County Name": "Sanpete", "Number of Charter Schools": 0 },
  { "County Name": "Sevier", "Number of Charter Schools": 0 },
  {
    "County Name": "Summit", "Number of Charter Schools": 2,
    "Charter Schools": [{
      "Charter School Name": "Winter Sports School",
      "Located at": "Park City, UT",
      "Website": "wintersportsschool.org"
    },
    {
      "Charter School Name": "Weilenmann School of Discovery",
      "Located at": "Park City, UT",
      "Website": "wsdpc.org"
    },
    ]
  },
  {
    "County Name": "Tooele", "Number of Charter Schools": 3,
    "Charter Schools": [
      { "Charter School Name": "Bonneville Academy", "Located at": "Stansbury Park, UT", "Website": "bonnevilleacademy.org" },
      { "Charter School Name": "Excelsior Academy", "Located at": "Erda, UT", "Website": "excelsior-academy.org" },
      { "Charter School Name": "Scholar Academy", "Located at": "Tooele, UT", "Website": "scholarcharter.org" },
    ]
  },

  { "County Name": "Uintah", "Number of Charter Schools": 2,
     "Charter Schools": [
      { "Charter School Name": "Terra Academy", "Located at": "Vernal, UT", "Website": "theterraacademy.org" },
      { "Charter School Name": "Uintah River High School", "Located at": "Fort Duchesne, UT", "Website": "uintahriverwarriors.org/urhs/urhs-home" },
     ]
   },

  {
    "County Name": "Utah",
    "Number of Charter Schools": 33,
    "Charter Schools": [
      { "Charter School Name": "American Leadership Academy", "Located at": "Spanish Fork, UT", "Website": "americanleadershipacademy.org" },
      { "Charter School Name": "American Preparatory Academy - Salem", "Located at": "Salem, UT", "Website": "salem.americanprep.org" },
      { "Charter School Name": "Aristotle Academy", "Located at": "American Fork, UT", "Website": "aristotleacademy.org" },
      { "Charter School Name": "Ascent Academies (Saratoga Springs)", "Located at": "Saratoga Springs, UT", "Website": "ascentutah.org/" },
      { "Charter School Name": "Ascent Academies of Utah Lehi", "Located at": "Lehi, UT", "Website": "farmington.ascentutah.org" },
      { "Charter School Name": "Athenian eAcademy", "Located at": "American Fork, UT", "Website": "aea.rocks" },
      { "Charter School Name": "Azure Fields Charter High School", "Located at": "Orem, UT", "Website": "azurefields.org" },
      { "Charter School Name": "Canyon Grove Academy", "Located at": "Pleasant Grove, UT", "Website": "http://www.canyongrove.com" },
      { "Charter School Name": "C.S. Lewis Academy", "Located at": "Santaquin, UT", "Website": "cslewisacademy.net" },
      { "Charter School Name": "Elevated Charter School", "Located at": "Lehi, UT", "Website": "elevatedcharterschool.org" },
      { "Charter School Name": "Franklin Discovery Academy", "Located at": "Vineyard, UT", "Website": "franklindiscovery.org" },
      { "Charter School Name": "Freedom Preparatory Academy - Provo Elementary and Secondary", "Located at": "Provo, UT", "Website": "freedomprep.net" },
      { "Charter School Name": "Freedom Preparatory Academy - Vineyard Elementary", "Located at": "Vineyard, UT", "Website": "freedomprep.net/vineyard-elementary" },
      { "Charter School Name": "Ignite Entrepreneurship Academy", "Located at": "Lehi, UT", "Website": "https://igniteutah.org/" },
      { "Charter School Name": "John Hancock Charter School", "Located at": "Pleasant Grove, UT", "Website": "johnhancockcs.org" },
      { "Charter School Name": "Karl G. Maeser Preparatory Academy", "Located at": "Lindon, UT", "Website": "maeserprep.org" },
      { "Charter School Name": "Lakeview Academy", "Located at": "Saratoga Springs, UT", "Website": "lakeview-academy.com/saratoga-springs/saratoga-springs-home" },
      { "Charter School Name": "Lincoln Academy", "Located at": "Pleasant Grove, UT", "Website": "lincoln-academy.org" },
      { "Charter School Name": "Merit College Preparatory Academy", "Located at": "Springville, UT", "Website": "meritprepacademy.org" },
      { "Charter School Name": "Mountainville Academy", "Located at": "Alpine, UT", "Website": "http://www.mountainvilleacademy.org" },
      { "Charter School Name": "Mountain Sunrise Academy", "Located at": "Saratoga Springs, UT", "Website": "mountainsunriseacademy.org" },
      { "Charter School Name": "Noah Webster Academy", "Located at": "Orem, UT", "Website": "noahwebsteracademy.org" },
      { "Charter School Name": "Odyssey Charter School", "Located at": "American Fork, UT", "Website": "odysseycharter.net" },
      { "Charter School Name": "Reagan Academy", "Located at": "Springville, UT", "Website": "reaganacademy.org" },
      { "Charter School Name": "Renaissance Academy", "Located at": "Lehi, UT", "Website": "renacademy.org" },
      { "Charter School Name": "Rockwell Charter High School", "Located at": "Eagle Mountain, UT", "Website": "rockwellhigh.net" },
      { "Charter School Name": "Spectrum Academy - Pleasant Grove", "Located at": "Pleasant Grove, UT", "Website": "spectrumcharter.org" },
      { "Charter School Name": "The Ranches Academy", "Located at": "Eagle Mountain, UT", "Website": "theranchesacademy.org" },
      { "Charter School Name": "Timpanogos Academy", "Located at": "Lindon, UT", "Website": "timpacademy.org" },
      { "Charter School Name": "Treeside Charter School", "Located at": "Provo, UT", "Website": "treesidecharterschool.org" },
      { "Charter School Name": "Utah County Academy of Sciences (UCAS)", "Located at": "Orem, UT", "Website": "ucas-edu.net" },
      { "Charter School Name": "Utah Military Academy - Camp Williams", "Located at": "Lehi, UT", "Website": "www.umavp.org" },
      { "Charter School Name": "Walden School of Liberal Arts", "Located at": "Provo, UT", "Website": "waldenschool.us" }
    ]
  },

  { "County Name": "Wasatch", "Number of Charter Schools": 1,
     "Charter Schools": [
      {
        "Charter School Name": "Soldier Hollow Charter School",
        "Located at": "Heber City, UT",
        "Website": "mysoldierhollow.com"
      },
    ]
   },
  {
    "County Name": "Washington", "Number of Charter Schools": 9,
    "Charter Schools": [
      {
        "Charter School Name": "Custom Class Charter School",
        "Located at": "St George, UT",
        "Website": "customclass.org"
      },
      {
        "Charter School Name": "Freedom Preparatory Academy Washington",
        "Located at": "St George, UT",
        "Website": "freedomprep.net"
      },
      {
        "Charter School Name": "George Washington Academy",
        "Located at": "St George, UT",
        "Website": "gwacademy.org"
      },
      {
        "Charter School Name": "Mountain View Montessori",
        "Located at": "Washington, UT",
        "Website": "mvmutah.org"
      },
      {
        "Charter School Name": "St. George Academy",
        "Located at": "Washington, UT",
        "Website": "stgacademy.org"
      },
      {
        "Charter School Name": "Success Academy at Utah Tech University",
        "Located at": "St George, UT",
        "Website": "utsuccess.org"
      },
      {
        "Charter School Name": "Utah Arts Academy",
        "Located at": "St George, UT",
        "Website": "utahartsacademy.org"
      },
      {
        "Charter School Name": "Valley Academy",
        "Located at": "Hurricane, UT",
        "Website": "valleyacademycharter.com"
      },
      {
        "Charter School Name": "Vista School",
        "Located at": "Ivins, UT",
        "Website": "vistautah.com"
      }
    ]
  },
  { "County Name": "Wayne", "Number of Charter Schools": 0 },
  {
    "County Name": "Weber", "Number of Charter Schools": 12,
    "Charter Schools": [
      {
        "Charter School Name": "Bridge Elementary School",
        "Located at": "Roy, UT",
        "Website": "bridgecharter.org"
      },
      {
        "Charter School Name": "DaVinci Academy",
        "Located at": "Ogden, UT",
        "Website": "davinciacademy.org"
      },
      {
        "Charter School Name": "Good Foundations Academy",
        "Located at": "Riverdale, UT",
        "Website": "gfautah.org"
      },
      {
        "Charter School Name": "Greenwood Charter School",
        "Located at": "Ogden, UT",
        "Website": "greenwoodcharter.org"
      },
      {
        "Charter School Name": "Leadership Learning Academy - Ogden",
        "Located at": "Ogden, UT",
        "Website": "llacharter.org/lc/lc-home?dh=1"
      },
      {
        "Charter School Name": "Maria Montessori Academy",
        "Located at": "Ogden, UT",
        "Website": "mariamontessoriacademy.org"
      },
      {
        "Charter School Name": "No. Ut. Academy of Math Engineering & Science Ogden",
        "Located at": "Ogden, UT",
        "Website": "nuames.org/dc/dc-home"
      },
      {
        "Charter School Name": "Ogden Preparatory Academy",
        "Located at": "Ogden, UT",
        "Website": "academica.org"
      },
      {
        "Charter School Name": "Quest Academy",
        "Located at": "West Haven, UT",
        "Website": "questac.org"
      }
    ]
  }
];




